import { avecLeNom } from './marque';

export let LANG = 'fr';

export const setLangGlobale = (l) => {
  LANG = l || 'fr';
};

/** La langue des jours et des mois affichés : le français de Suisse, ou celle de l'écran. */
export const localeDates = () => (String(LANG).startsWith('fr') ? 'fr-CH' : LANG);

export const I18N = {
  en: {
    Accueil: 'Home',
    Ventes: 'Sales',
    Offres: 'Quotes',
    Devis: 'Quote',
    Chantiers: 'Projects',
    Factures: 'Invoices',
    Équipe: 'Team',
    Plus: 'More',
    FACTURE: 'INVOICE',
    DEVIS: 'QUOTE',
    Montant: 'Amount',
    Référence: 'Reference',
    'En faveur de': 'In favour of',
    Récépissé: 'Receipt',
    'Section paiement': 'Payment section',
    Comptabilité: 'Accounting',
    Stock: 'Stock',
    'Équipe & paie': 'Team & payroll',
    Clients: 'Clients',
    'Rendez-vous': 'Appointments',
    Planning: 'Planning',
    Commandes: 'Orders',
    Livraisons: 'Deliveries',
    Remises: 'Discounts',
    Notifications: 'Notifications',
    Réglages: 'Settings',
    Dépenses: 'Expenses',
    'Ajouter un article': 'Add item',
    Articles: 'Items',
    'Tableau de bord': 'Dashboard',
    Paramètres: 'Settings',
  },
  de: {
    Accueil: 'Start',
    Ventes: 'Verkauf',
    Offres: 'Offerten',
    Devis: 'Offerte',
    Chantiers: 'Baustellen',
    Factures: 'Rechnungen',
    Équipe: 'Team',
    Plus: 'Mehr',
    FACTURE: 'RECHNUNG',
    DEVIS: 'OFFERTE',
    Montant: 'Betrag',
    Référence: 'Referenz',
    'En faveur de': 'Zugunsten von',
    Récépissé: 'Empfangsschein',
    'Section paiement': 'Zahlteil',
    Comptabilité: 'Buchhaltung',
    Stock: 'Lager',
    'Équipe & paie': 'Team & Lohn',
    Clients: 'Kunden',
    'Rendez-vous': 'Termine',
    Planning: 'Planung',
    Commandes: 'Bestellungen',
    Livraisons: 'Lieferungen',
    Remises: 'Rabatte',
    Notifications: 'Mitteilungen',
    Réglages: 'Einstellungen',
    Dépenses: 'Ausgaben',
    'Ajouter un article': 'Artikel hinzufügen',
    Articles: 'Artikel',
    'Tableau de bord': 'Übersicht',
  },
  it: {
    Accueil: 'Home',
    Ventes: 'Vendite',
    Offres: 'Offerte',
    Devis: 'Preventivo',
    Chantiers: 'Cantieri',
    Factures: 'Fatture',
    Équipe: 'Squadra',
    Plus: 'Altro',
    FACTURE: 'FATTURA',
    DEVIS: 'PREVENTIVO',
    Montant: 'Importo',
    Référence: 'Riferimento',
    'En faveur de': 'A favore di',
    Récépissé: 'Ricevuta',
    'Section paiement': 'Sezione pagamento',
    Comptabilité: 'Contabilità',
    Stock: 'Magazzino',
    'Équipe & paie': 'Squadra & paghe',
    Clients: 'Clienti',
    'Rendez-vous': 'Appuntamenti',
    Planning: 'Pianificazione',
    Commandes: 'Ordini',
    Livraisons: 'Consegne',
    Remises: 'Sconti',
    Notifications: 'Notifiche',
    Réglages: 'Impostazioni',
    Dépenses: 'Spese',
    'Ajouter un article': 'Aggiungi articolo',
    Articles: 'Articoli',
    'Tableau de bord': 'Cruscotto',
  },
  es: {
    Accueil: 'Inicio',
    Ventes: 'Ventas',
    Offres: 'Presupuestos',
    Devis: 'Presupuesto',
    Chantiers: 'Obras',
    Factures: 'Facturas',
    Équipe: 'Equipo',
    Plus: 'Más',
    FACTURE: 'FACTURA',
    DEVIS: 'PRESUPUESTO',
    Montant: 'Importe',
    Référence: 'Referencia',
    'En faveur de': 'A favor de',
    Récépissé: 'Recibo',
    'Section paiement': 'Sección de pago',
    Comptabilité: 'Contabilidad',
    Stock: 'Inventario',
    'Équipe & paie': 'Equipo y nómina',
    Clients: 'Clientes',
    'Rendez-vous': 'Citas',
    Planning: 'Planificación',
    Commandes: 'Pedidos',
    Livraisons: 'Entregas',
    Remises: 'Descuentos',
    Notifications: 'Notificaciones',
    Réglages: 'Ajustes',
    Dépenses: 'Gastos',
    'Ajouter un article': 'Añadir artículo',
    Articles: 'Artículos',
    'Tableau de bord': 'Panel',
  },
};

export const tr = (s) => avecLeNom((I18N[LANG] && I18N[LANG][s]) || s);

/**
 * Traduit un modèle « Acompte {0}% » et y place les valeurs. En français, le
 * résultat est la phrase d'origine.
 *
 * @param {string} modele texte français, avec {0}, {1}…
 * @param {...*} valeurs valeurs à placer
 * @returns {string} la phrase traduite et remplie
 */
export const trf = (modele, ...valeurs) =>
  tr(modele).replace(/\{(\d+)(\|?)\}/g, (x, n, muet) =>
    muet || valeurs[n] == null ? '' : String(valeurs[n]),
  );

/**
 * Ajoute le dictionnaire complet d'une langue (src/i18n) à celui des mots de
 * base : les documents l'utilisent par {@link tr}. Les mots de base, choisis
 * un à un, gardent la priorité.
 *
 * @param {string} langue code de la langue
 * @param {object} dictionnaire textes français → traduction
 */
export const enregistreDictionnaire = (langue, dictionnaire) => {
  I18N[langue] = { ...(dictionnaire || {}), ...(I18N[langue] || {}) };
};

export const trU = (s) => {
  if (typeof s !== 'string' || !s) return s;
  const d = I18N[LANG];
  if (!d) return avecLeNom(s);
  if (d[s]) return avecLeNom(d[s]);
  const m = s.match(/^(\S+)\s+([\s\S]*)$/);
  if (m && d[m[2]]) return avecLeNom(m[1] + ' ' + d[m[2]]);
  return avecLeNom(s);
};

I18N.pt = {
  'Novo orçamento': 'Novo orçamento',
  Accueil: 'Início',
  Ventes: 'Vendas',
  Offres: 'Orçamentos',
  Devis: 'Orçamento',
  Chantiers: 'Obras',
  Factures: 'Faturas',
  Équipe: 'Equipa',
  Plus: 'Mais',
  Comptabilité: 'Contabilidade',
  Stock: 'Stock',
  Clients: 'Clientes',
  'Rendez-vous': 'Compromissos',
  Planning: 'Planeamento',
  Commandes: 'Encomendas',
  Livraisons: 'Entregas',
  Remises: 'Descontos',
  Notifications: 'Notificações',
  Réglages: 'Definições',
  Dépenses: 'Despesas',
  Enregistrer: 'Guardar',
  Annuler: 'Cancelar',
  Ajouter: 'Adicionar',
  Continuer: 'Continuar',
  Commencer: 'Começar',
  Fermer: 'Fechar',
  Modifier: 'Editar',
  Supprimer: 'Eliminar',
  Valider: 'Confirmar',
  Envoyer: 'Enviar',
  Imprimer: 'Imprimir',
  Partager: 'Partilhar',
  Retour: 'Voltar',
  Suivant: 'Seguinte',
  Nouveau: 'Novo',
  Rechercher: 'Procurar',
  Date: 'Data',
  Client: 'Cliente',
  Adresse: 'Endereço',
  Description: 'Descrição',
  Quantité: 'Quantidade',
  Prix: 'Preço',
  Unité: 'Unidade',
  Total: 'Total',
  Remise: 'Desconto',
  TVA: 'IVA',
  Acompte: 'Sinal',
  Solde: 'Saldo',
  Téléphone: 'Telefone',
  Email: 'Email',
  Nom: 'Nome',
  Société: 'Empresa',
  Statut: 'Estado',
  Payée: 'Paga',
  Envoyée: 'Enviada',
  'En attente': 'Pendente',
  Brouillon: 'Rascunho',
  Accepté: 'Aceite',
  Refusé: 'Recusado',
  Terminé: 'Concluído',
  'En cours': 'Em curso',
  Fournisseur: 'Fornecedor',
  Salaire: 'Salário',
  Heures: 'Horas',
  'Montant HT': 'Valor s/IVA',
  'Montant TTC': 'Valor c/IVA',
};
I18N.fr = {
  'Nouveau devis': 'Nouveau devis',
  Accueil: 'Accueil',
  Ventes: 'Ventes',
  Offres: 'Offres',
  Devis: 'Devis',
  Chantiers: 'Chantiers',
  Factures: 'Factures',
  Équipe: 'Équipe',
  Plus: 'Plus',
  Comptabilité: 'Comptabilité',
  Stock: 'Stock',
  Clients: 'Clients',
  'Rendez-vous': 'Rendez-vous',
  Planning: 'Planning',
  Commandes: 'Commandes',
  Livraisons: 'Livraisons',
  Remises: 'Remises',
  Notifications: 'Notifications',
  Réglages: 'Réglages',
  Dépenses: 'Dépenses',
  Enregistrer: 'Enregistrer',
  Annuler: 'Annuler',
  Ajouter: 'Ajouter',
  Continuer: 'Continuer',
  Commencer: 'Commencer',
  Fermer: 'Fermer',
  Modifier: 'Modifier',
  Supprimer: 'Supprimer',
  Valider: 'Valider',
  Envoyer: 'Envoyer',
  Imprimer: 'Imprimer',
  Partager: 'Partager',
  Retour: 'Retour',
  Suivant: 'Suivant',
  Nouveau: 'Nouveau',
  Rechercher: 'Rechercher',
  Date: 'Date',
  Client: 'Client',
  Adresse: 'Adresse',
  Description: 'Description',
  Quantité: 'Quantité',
  Prix: 'Prix',
  Unité: 'Unité',
  Total: 'Total',
  Remise: 'Remise',
  TVA: 'TVA',
  Acompte: 'Acompte',
  Solde: 'Solde',
  Téléphone: 'Téléphone',
  Email: 'Email',
  Nom: 'Nom',
  Société: 'Société',
  Statut: 'Statut',
  Payée: 'Payée',
  Envoyée: 'Envoyée',
  'En attente': 'En attente',
  Brouillon: 'Brouillon',
  Accepté: 'Accepté',
  Refusé: 'Refusé',
  Terminé: 'Terminé',
  'En cours': 'En cours',
  Fournisseur: 'Fournisseur',
  Salaire: 'Salaire',
  Heures: 'Heures',
  'Montant HT': 'Montant HT',
  'Montant TTC': 'Montant TTC',
};
I18N['fr-CH'] = {
  devis: 'offre',
  DEVIS: 'OFFRE',
  'Devis simple': 'Offre simple',
  'Devis détaillé': 'Offre détaillée',
  'Devis établi pour': 'Offre établie pour',
  'Devis ': 'Offre ',
  'Nouveau devis': 'Nouvelle offre',
  Accueil: 'Accueil',
  Ventes: 'Ventes',
  Offres: 'Offres',
  Devis: 'Offre',
  Chantiers: 'Chantiers',
  Factures: 'Factures',
  Équipe: 'Équipe',
  Plus: 'Plus',
  Comptabilité: 'Comptabilité',
  Stock: 'Stock',
  Clients: 'Clients',
  'Rendez-vous': 'Rendez-vous',
  Planning: 'Planning',
  Commandes: 'Commandes',
  Livraisons: 'Livraisons',
  Remises: 'Remises',
  Notifications: 'Notifications',
  Réglages: 'Réglages',
  Dépenses: 'Dépenses',
  Enregistrer: 'Enregistrer',
  Annuler: 'Annuler',
  Ajouter: 'Ajouter',
  Continuer: 'Continuer',
  Commencer: 'Commencer',
  Fermer: 'Fermer',
  Modifier: 'Modifier',
  Supprimer: 'Supprimer',
  Valider: 'Valider',
  Envoyer: 'Envoyer',
  Imprimer: 'Imprimer',
  Partager: 'Partager',
  Retour: 'Retour',
  Suivant: 'Suivant',
  Nouveau: 'Nouveau',
  Rechercher: 'Rechercher',
  Date: 'Date',
  Client: 'Client',
  Adresse: 'Adresse',
  Description: 'Description',
  Quantité: 'Quantité',
  Prix: 'Prix',
  Unité: 'Unité',
  Total: 'Total',
  Remise: 'Remise',
  TVA: 'TVA',
  Acompte: 'Acompte',
  Solde: 'Solde',
  Téléphone: 'Téléphone',
  Email: 'Email',
  Nom: 'Nom',
  Société: 'Société',
  Statut: 'Statut',
  Payée: 'Payée',
  Envoyée: 'Envoyée',
  'En attente': 'En attente',
  Brouillon: 'Brouillon',
  Accepté: 'Accepté',
  Refusé: 'Refusé',
  Terminé: 'Terminé',
  'En cours': 'En cours',
  Fournisseur: 'Fournisseur',
  Salaire: 'Salaire',
  Heures: 'Heures',
  'Montant HT': 'Montant HT',
  'Montant TTC': 'Montant TTC',
};

I18N.nl = {
  'Nieuw offerte': 'Nieuw offerte',
  Accueil: 'Start',
  Ventes: 'Verkoop',
  Offres: 'Offertes',
  Devis: 'Offerte',
  Chantiers: 'Werven',
  Factures: 'Facturen',
  Équipe: 'Team',
  Plus: 'Meer',
  Comptabilité: 'Boekhouding',
  Stock: 'Voorraad',
  Clients: 'Klanten',
  'Rendez-vous': 'Afspraken',
  Planning: 'Planning',
  Commandes: 'Bestellingen',
  Livraisons: 'Leveringen',
  Remises: 'Kortingen',
  Notifications: 'Meldingen',
  Réglages: 'Instellingen',
  Dépenses: 'Uitgaven',
  Enregistrer: 'Opslaan',
  Annuler: 'Annuleren',
  Ajouter: 'Toevoegen',
  Continuer: 'Doorgaan',
  Commencer: 'Starten',
  Fermer: 'Sluiten',
  Modifier: 'Bewerken',
  Supprimer: 'Verwijderen',
  Valider: 'Bevestigen',
  Envoyer: 'Versturen',
  Imprimer: 'Afdrukken',
  Partager: 'Delen',
  Retour: 'Terug',
  Suivant: 'Volgende',
  Nouveau: 'Nieuw',
  Rechercher: 'Zoeken',
  Date: 'Datum',
  Client: 'Klant',
  Adresse: 'Adres',
  Description: 'Omschrijving',
  Quantité: 'Aantal',
  Prix: 'Prijs',
  Unité: 'Eenheid',
  Total: 'Totaal',
  Remise: 'Korting',
  TVA: 'btw',
  Acompte: 'Voorschot',
  Solde: 'Saldo',
  Téléphone: 'Telefoon',
  Email: 'E-mail',
  Nom: 'Naam',
  Société: 'Bedrijf',
  Statut: 'Status',
  Payée: 'Betaald',
  Envoyée: 'Verzonden',
  'En attente': 'In afwachting',
  Brouillon: 'Concept',
  Accepté: 'Geaccepteerd',
  Refusé: 'Geweigerd',
  Terminé: 'Voltooid',
  'En cours': 'Lopend',
  Fournisseur: 'Leverancier',
  Salaire: 'Loon',
  Heures: 'Uren',
  'Montant HT': 'Bedrag excl. btw',
  'Montant TTC': 'Bedrag incl. btw',
};
I18N.pl = {
  Accueil: 'Start',
  Ventes: 'Sprzedaż',
  Offres: 'Oferty',
  Devis: 'Oferta',
  Chantiers: 'Budowy',
  Factures: 'Faktury',
  Équipe: 'Zespół',
  Plus: 'Więcej',
  Comptabilité: 'Księgowość',
  Stock: 'Magazyn',
  Clients: 'Klienci',
  'Rendez-vous': 'Spotkania',
  Planning: 'Harmonogram',
  Commandes: 'Zamówienia',
  Livraisons: 'Dostawy',
  Remises: 'Rabaty',
  Notifications: 'Powiadomienia',
  Réglages: 'Ustawienia',
  Dépenses: 'Wydatki',
  Enregistrer: 'Zapisz',
  Annuler: 'Anuluj',
  Ajouter: 'Dodaj',
  Continuer: 'Kontynuuj',
  Commencer: 'Rozpocznij',
  Fermer: 'Zamknij',
  Modifier: 'Edytuj',
  Supprimer: 'Usuń',
  Valider: 'Potwierdź',
  Envoyer: 'Wyślij',
  Imprimer: 'Drukuj',
  Partager: 'Udostępnij',
  Retour: 'Wstecz',
  Suivant: 'Dalej',
  Nouveau: 'Nowy',
  Rechercher: 'Szukaj',
  Date: 'Data',
  Client: 'Klient',
  Adresse: 'Adres',
  Description: 'Opis',
  Quantité: 'Ilość',
  Prix: 'Cena',
  Unité: 'Jednostka',
  Total: 'Razem',
  Remise: 'Rabat',
  TVA: 'VAT',
  Acompte: 'Zaliczka',
  Solde: 'Saldo',
  Téléphone: 'Telefon',
  Email: 'E-mail',
  Nom: 'Nazwa',
  Société: 'Firma',
  Statut: 'Status',
  Payée: 'Opłacona',
  Envoyée: 'Wysłana',
  'En attente': 'Oczekuje',
  Brouillon: 'Wersja robocza',
  Accepté: 'Zaakceptowano',
  Refusé: 'Odrzucono',
  Terminé: 'Zakończone',
  'En cours': 'W toku',
  Fournisseur: 'Dostawca',
  Salaire: 'Wynagrodzenie',
  Heures: 'Godziny',
  'Montant HT': 'Kwota netto',
  'Montant TTC': 'Kwota brutto',
};
I18N.sv = {
  Accueil: 'Hem',
  Ventes: 'Försäljning',
  Offres: 'Offerter',
  Devis: 'Offert',
  Chantiers: 'Projekt',
  Factures: 'Fakturor',
  Équipe: 'Team',
  Plus: 'Mer',
  Comptabilité: 'Bokföring',
  Stock: 'Lager',
  Clients: 'Kunder',
  'Rendez-vous': 'Möten',
  Planning: 'Planering',
  Commandes: 'Beställningar',
  Livraisons: 'Leveranser',
  Remises: 'Rabatter',
  Notifications: 'Aviseringar',
  Réglages: 'Inställningar',
  Dépenses: 'Utgifter',
  Enregistrer: 'Spara',
  Annuler: 'Avbryt',
  Ajouter: 'Lägg till',
  Envoyer: 'Skicka',
  Imprimer: 'Skriv ut',
  Retour: 'Tillbaka',
  Nouveau: 'Ny',
  Rechercher: 'Sök',
  Date: 'Datum',
  Client: 'Kund',
  Total: 'Totalt',
  TVA: 'Moms',
  Statut: 'Status',
  Payée: 'Betald',
  Envoyée: 'Skickad',
  'En attente': 'Väntar',
  Brouillon: 'Utkast',
  Terminé: 'Klar',
};
I18N.da = {
  Accueil: 'Hjem',
  Ventes: 'Salg',
  Offres: 'Tilbud',
  Devis: 'Tilbud',
  Chantiers: 'Projekter',
  Factures: 'Fakturaer',
  Équipe: 'Team',
  Plus: 'Mere',
  Comptabilité: 'Bogføring',
  Stock: 'Lager',
  Clients: 'Kunder',
  'Rendez-vous': 'Møder',
  Planning: 'Planlægning',
  Commandes: 'Ordrer',
  Livraisons: 'Leveringer',
  Remises: 'Rabatter',
  Notifications: 'Notifikationer',
  Réglages: 'Indstillinger',
  Dépenses: 'Udgifter',
  Enregistrer: 'Gem',
  Annuler: 'Annuller',
  Ajouter: 'Tilføj',
  Envoyer: 'Send',
  Imprimer: 'Udskriv',
  Retour: 'Tilbage',
  Nouveau: 'Ny',
  Rechercher: 'Søg',
  Date: 'Dato',
  Client: 'Kunde',
  Total: 'I alt',
  TVA: 'Moms',
  Statut: 'Status',
  Payée: 'Betalt',
  Envoyée: 'Sendt',
  'En attente': 'Afventer',
  Brouillon: 'Kladde',
  Terminé: 'Færdig',
};
I18N.no = {
  Accueil: 'Hjem',
  Ventes: 'Salg',
  Offres: 'Tilbud',
  Devis: 'Tilbud',
  Chantiers: 'Prosjekter',
  Factures: 'Fakturaer',
  Équipe: 'Team',
  Plus: 'Mer',
  Comptabilité: 'Regnskap',
  Stock: 'Lager',
  Clients: 'Kunder',
  'Rendez-vous': 'Møter',
  Planning: 'Planlegging',
  Commandes: 'Bestillinger',
  Livraisons: 'Leveringer',
  Remises: 'Rabatter',
  Notifications: 'Varsler',
  Réglages: 'Innstillinger',
  Dépenses: 'Utgifter',
  Enregistrer: 'Lagre',
  Annuler: 'Avbryt',
  Ajouter: 'Legg til',
  Envoyer: 'Send',
  Imprimer: 'Skriv ut',
  Retour: 'Tilbake',
  Nouveau: 'Ny',
  Rechercher: 'Søk',
  Date: 'Dato',
  Client: 'Kunde',
  Total: 'Totalt',
  TVA: 'MVA',
  Statut: 'Status',
  Payée: 'Betalt',
  Envoyée: 'Sendt',
  'En attente': 'Venter',
  Brouillon: 'Utkast',
  Terminé: 'Ferdig',
};
I18N.fi = {
  Accueil: 'Koti',
  Ventes: 'Myynti',
  Offres: 'Tarjoukset',
  Devis: 'Tarjous',
  Chantiers: 'Työmaat',
  Factures: 'Laskut',
  Équipe: 'Tiimi',
  Plus: 'Lisää',
  Comptabilité: 'Kirjanpito',
  Stock: 'Varasto',
  Clients: 'Asiakkaat',
  'Rendez-vous': 'Tapaamiset',
  Planning: 'Suunnittelu',
  Commandes: 'Tilaukset',
  Livraisons: 'Toimitukset',
  Remises: 'Alennukset',
  Notifications: 'Ilmoitukset',
  Réglages: 'Asetukset',
  Dépenses: 'Kulut',
  Enregistrer: 'Tallenna',
  Annuler: 'Peruuta',
  Ajouter: 'Lisää',
  Envoyer: 'Lähetä',
  Imprimer: 'Tulosta',
  Retour: 'Takaisin',
  Nouveau: 'Uusi',
  Rechercher: 'Hae',
  Date: 'Päivä',
  Client: 'Asiakas',
  Total: 'Yhteensä',
  TVA: 'ALV',
  Statut: 'Tila',
  Payée: 'Maksettu',
  Envoyée: 'Lähetetty',
  'En attente': 'Odottaa',
  Brouillon: 'Luonnos',
  Terminé: 'Valmis',
};
I18N.cs = {
  Accueil: 'Domů',
  Ventes: 'Prodej',
  Offres: 'Nabídky',
  Devis: 'Nabídka',
  Chantiers: 'Stavby',
  Factures: 'Faktury',
  Équipe: 'Tým',
  Plus: 'Více',
  Comptabilité: 'Účetnictví',
  Stock: 'Sklad',
  Clients: 'Zákazníci',
  'Rendez-vous': 'Schůzky',
  Planning: 'Plánování',
  Commandes: 'Objednávky',
  Livraisons: 'Dodávky',
  Remises: 'Slevy',
  Notifications: 'Oznámení',
  Réglages: 'Nastavení',
  Dépenses: 'Výdaje',
  Enregistrer: 'Uložit',
  Annuler: 'Zrušit',
  Ajouter: 'Přidat',
  Envoyer: 'Odeslat',
  Imprimer: 'Tisk',
  Retour: 'Zpět',
  Nouveau: 'Nový',
  Rechercher: 'Hledat',
  Date: 'Datum',
  Client: 'Zákazník',
  Total: 'Celkem',
  TVA: 'DPH',
  Statut: 'Stav',
  Payée: 'Zaplaceno',
  Envoyée: 'Odesláno',
  'En attente': 'Čeká',
  Brouillon: 'Koncept',
  Terminé: 'Hotovo',
};
I18N.ro = {
  Accueil: 'Acasă',
  Ventes: 'Vânzări',
  Offres: 'Oferte',
  Devis: 'Deviz',
  Chantiers: 'Șantiere',
  Factures: 'Facturi',
  Équipe: 'Echipă',
  Plus: 'Mai mult',
  Comptabilité: 'Contabilitate',
  Stock: 'Stoc',
  Clients: 'Clienți',
  'Rendez-vous': 'Programări',
  Planning: 'Planificare',
  Commandes: 'Comenzi',
  Livraisons: 'Livrări',
  Remises: 'Reduceri',
  Notifications: 'Notificări',
  Réglages: 'Setări',
  Dépenses: 'Cheltuieli',
  Enregistrer: 'Salvează',
  Annuler: 'Anulează',
  Ajouter: 'Adaugă',
  Envoyer: 'Trimite',
  Imprimer: 'Tipărește',
  Retour: 'Înapoi',
  Nouveau: 'Nou',
  Rechercher: 'Caută',
  Date: 'Dată',
  Client: 'Client',
  Total: 'Total',
  TVA: 'TVA',
  Statut: 'Stare',
  Payée: 'Plătită',
  Envoyée: 'Trimisă',
  'En attente': 'În așteptare',
  Brouillon: 'Ciornă',
  Terminé: 'Finalizat',
};
I18N.hu = {
  Accueil: 'Kezdőlap',
  Ventes: 'Értékesítés',
  Offres: 'Ajánlatok',
  Devis: 'Ajánlat',
  Chantiers: 'Munkák',
  Factures: 'Számlák',
  Équipe: 'Csapat',
  Plus: 'Több',
  Comptabilité: 'Könyvelés',
  Stock: 'Készlet',
  Clients: 'Ügyfelek',
  'Rendez-vous': 'Találkozók',
  Planning: 'Tervezés',
  Commandes: 'Rendelések',
  Livraisons: 'Szállítások',
  Remises: 'Kedvezmények',
  Notifications: 'Értesítések',
  Réglages: 'Beállítások',
  Dépenses: 'Kiadások',
  Enregistrer: 'Mentés',
  Annuler: 'Mégse',
  Ajouter: 'Hozzáadás',
  Envoyer: 'Küldés',
  Imprimer: 'Nyomtatás',
  Retour: 'Vissza',
  Nouveau: 'Új',
  Rechercher: 'Keresés',
  Date: 'Dátum',
  Client: 'Ügyfél',
  Total: 'Összesen',
  TVA: 'ÁFA',
  Statut: 'Állapot',
  Payée: 'Fizetve',
  Envoyée: 'Elküldve',
  'En attente': 'Függőben',
  Brouillon: 'Vázlat',
  Terminé: 'Kész',
};
I18N.hr = {
  Accueil: 'Početna',
  Ventes: 'Prodaja',
  Offres: 'Ponude',
  Devis: 'Ponuda',
  Chantiers: 'Gradilišta',
  Factures: 'Računi',
  Équipe: 'Tim',
  Plus: 'Više',
  Comptabilité: 'Računovodstvo',
  Stock: 'Skladište',
  Clients: 'Klijenti',
  'Rendez-vous': 'Sastanci',
  Planning: 'Planiranje',
  Commandes: 'Narudžbe',
  Livraisons: 'Isporuke',
  Remises: 'Popusti',
  Notifications: 'Obavijesti',
  Réglages: 'Postavke',
  Dépenses: 'Troškovi',
  Enregistrer: 'Spremi',
  Annuler: 'Odustani',
  Ajouter: 'Dodaj',
  Envoyer: 'Pošalji',
  Imprimer: 'Ispiši',
  Retour: 'Natrag',
  Nouveau: 'Novo',
  Rechercher: 'Traži',
  Date: 'Datum',
  Client: 'Klijent',
  Total: 'Ukupno',
  TVA: 'PDV',
  Statut: 'Status',
  Payée: 'Plaćeno',
  Envoyée: 'Poslano',
  'En attente': 'Na čekanju',
  Brouillon: 'Skica',
  Terminé: 'Završeno',
};
I18N.sk = {
  Accueil: 'Domov',
  Ventes: 'Predaj',
  Offres: 'Ponuky',
  Devis: 'Ponuka',
  Chantiers: 'Stavby',
  Factures: 'Faktúry',
  Équipe: 'Tím',
  Plus: 'Viac',
  Comptabilité: 'Účtovníctvo',
  Stock: 'Sklad',
  Clients: 'Zákazníci',
  'Rendez-vous': 'Stretnutia',
  Planning: 'Plánovanie',
  Commandes: 'Objednávky',
  Livraisons: 'Dodávky',
  Remises: 'Zľavy',
  Notifications: 'Oznámenia',
  Réglages: 'Nastavenia',
  Dépenses: 'Výdavky',
  Enregistrer: 'Uložiť',
  Annuler: 'Zrušiť',
  Ajouter: 'Pridať',
  Envoyer: 'Odoslať',
  Imprimer: 'Tlačiť',
  Retour: 'Späť',
  Nouveau: 'Nový',
  Rechercher: 'Hľadať',
  Date: 'Dátum',
  Client: 'Zákazník',
  Total: 'Spolu',
  TVA: 'DPH',
  Statut: 'Stav',
  Payée: 'Zaplatené',
  Envoyée: 'Odoslané',
  'En attente': 'Čaká',
  Brouillon: 'Koncept',
  Terminé: 'Hotovo',
};
I18N.sl = {
  Accueil: 'Domov',
  Ventes: 'Prodaja',
  Offres: 'Ponudbe',
  Devis: 'Ponudba',
  Chantiers: 'Gradbišča',
  Factures: 'Računi',
  Équipe: 'Ekipa',
  Plus: 'Več',
  Comptabilité: 'Računovodstvo',
  Stock: 'Zaloga',
  Clients: 'Stranke',
  'Rendez-vous': 'Sestanki',
  Planning: 'Načrtovanje',
  Commandes: 'Naročila',
  Livraisons: 'Dostave',
  Remises: 'Popusti',
  Notifications: 'Obvestila',
  Réglages: 'Nastavitve',
  Dépenses: 'Stroški',
  Enregistrer: 'Shrani',
  Annuler: 'Prekliči',
  Ajouter: 'Dodaj',
  Envoyer: 'Pošlji',
  Imprimer: 'Natisni',
  Retour: 'Nazaj',
  Nouveau: 'Novo',
  Rechercher: 'Iskanje',
  Date: 'Datum',
  Client: 'Stranka',
  Total: 'Skupaj',
  TVA: 'DDV',
  Statut: 'Status',
  Payée: 'Plačano',
  Envoyée: 'Poslano',
  'En attente': 'V čakanju',
  Brouillon: 'Osnutek',
  Terminé: 'Končano',
};
I18N.et = {
  Accueil: 'Avaleht',
  Ventes: 'Müük',
  Offres: 'Pakkumised',
  Devis: 'Pakkumine',
  Chantiers: 'Objektid',
  Factures: 'Arved',
  Équipe: 'Meeskond',
  Plus: 'Veel',
  Comptabilité: 'Raamatupidamine',
  Stock: 'Ladu',
  Clients: 'Kliendid',
  'Rendez-vous': 'Kohtumised',
  Planning: 'Planeerimine',
  Commandes: 'Tellimused',
  Livraisons: 'Tarned',
  Remises: 'Allahindlused',
  Notifications: 'Teated',
  Réglages: 'Seaded',
  Dépenses: 'Kulud',
  Enregistrer: 'Salvesta',
  Annuler: 'Tühista',
  Ajouter: 'Lisa',
  Envoyer: 'Saada',
  Imprimer: 'Prindi',
  Retour: 'Tagasi',
  Nouveau: 'Uus',
  Rechercher: 'Otsi',
  Date: 'Kuupäev',
  Client: 'Klient',
  Total: 'Kokku',
  TVA: 'KM',
  Statut: 'Olek',
  Payée: 'Makstud',
  Envoyée: 'Saadetud',
  'En attente': 'Ootel',
  Brouillon: 'Mustand',
  Terminé: 'Valmis',
};
I18N.lv = {
  Accueil: 'Sākums',
  Ventes: 'Pārdošana',
  Offres: 'Piedāvājumi',
  Devis: 'Piedāvājums',
  Chantiers: 'Objekti',
  Factures: 'Rēķini',
  Équipe: 'Komanda',
  Plus: 'Vairāk',
  Comptabilité: 'Grāmatvedība',
  Stock: 'Noliktava',
  Clients: 'Klienti',
  'Rendez-vous': 'Tikšanās',
  Planning: 'Plānošana',
  Commandes: 'Pasūtījumi',
  Livraisons: 'Piegādes',
  Remises: 'Atlaides',
  Notifications: 'Paziņojumi',
  Réglages: 'Iestatījumi',
  Dépenses: 'Izdevumi',
  Enregistrer: 'Saglabāt',
  Annuler: 'Atcelt',
  Ajouter: 'Pievienot',
  Envoyer: 'Sūtīt',
  Imprimer: 'Drukāt',
  Retour: 'Atpakaļ',
  Nouveau: 'Jauns',
  Rechercher: 'Meklēt',
  Date: 'Datums',
  Client: 'Klients',
  Total: 'Kopā',
  TVA: 'PVN',
  Statut: 'Statuss',
  Payée: 'Apmaksāts',
  Envoyée: 'Nosūtīts',
  'En attente': 'Gaida',
  Brouillon: 'Melnraksts',
  Terminé: 'Pabeigts',
};
I18N.lt = {
  Accueil: 'Pradžia',
  Ventes: 'Pardavimai',
  Offres: 'Pasiūlymai',
  Devis: 'Pasiūlymas',
  Chantiers: 'Objektai',
  Factures: 'Sąskaitos',
  Équipe: 'Komanda',
  Plus: 'Daugiau',
  Comptabilité: 'Apskaita',
  Stock: 'Sandėlis',
  Clients: 'Klientai',
  'Rendez-vous': 'Susitikimai',
  Planning: 'Planavimas',
  Commandes: 'Užsakymai',
  Livraisons: 'Pristatymai',
  Remises: 'Nuolaidos',
  Notifications: 'Pranešimai',
  Réglages: 'Nustatymai',
  Dépenses: 'Išlaidos',
  Enregistrer: 'Išsaugoti',
  Annuler: 'Atšaukti',
  Ajouter: 'Pridėti',
  Envoyer: 'Siųsti',
  Imprimer: 'Spausdinti',
  Retour: 'Atgal',
  Nouveau: 'Naujas',
  Rechercher: 'Ieškoti',
  Date: 'Data',
  Client: 'Klientas',
  Total: 'Iš viso',
  TVA: 'PVM',
  Statut: 'Būsena',
  Payée: 'Apmokėta',
  Envoyée: 'Išsiųsta',
  'En attente': 'Laukiama',
  Brouillon: 'Juodraštis',
  Terminé: 'Baigta',
};
I18N.sq = {
  Accueil: 'Ballina',
  Ventes: 'Shitjet',
  Offres: 'Ofertat',
  Devis: 'Oferta',
  Chantiers: 'Kantieret',
  Factures: 'Faturat',
  Équipe: 'Ekipi',
  Plus: 'Më shumë',
  Comptabilité: 'Kontabiliteti',
  Stock: 'Stoku',
  Clients: 'Klientët',
  'Rendez-vous': 'Takimet',
  Planning: 'Planifikimi',
  Commandes: 'Porositë',
  Livraisons: 'Dërgesat',
  Remises: 'Zbritjet',
  Notifications: 'Njoftimet',
  Réglages: 'Cilësimet',
  Dépenses: 'Shpenzimet',
  Enregistrer: 'Ruaj',
  Annuler: 'Anulo',
  Ajouter: 'Shto',
  Envoyer: 'Dërgo',
  Imprimer: 'Printo',
  Retour: 'Kthehu',
  Nouveau: 'I ri',
  Rechercher: 'Kërko',
  Date: 'Data',
  Client: 'Klienti',
  Total: 'Totali',
  TVA: 'TVSH',
  Statut: 'Statusi',
  Payée: 'Paguar',
  Envoyée: 'Dërguar',
  'En attente': 'Në pritje',
  Brouillon: 'Skicë',
  Terminé: 'Përfunduar',
};
I18N.is = {
  Accueil: 'Heim',
  Ventes: 'Sala',
  Offres: 'Tilboð',
  Devis: 'Tilboð',
  Chantiers: 'Verk',
  Factures: 'Reikningar',
  Équipe: 'Teymi',
  Plus: 'Meira',
  Comptabilité: 'Bókhald',
  Stock: 'Lager',
  Clients: 'Viðskiptavinir',
  'Rendez-vous': 'Fundir',
  Planning: 'Áætlun',
  Commandes: 'Pantanir',
  Livraisons: 'Afhendingar',
  Remises: 'Afslættir',
  Notifications: 'Tilkynningar',
  Réglages: 'Stillingar',
  Dépenses: 'Útgjöld',
  Enregistrer: 'Vista',
  Annuler: 'Hætta við',
  Ajouter: 'Bæta við',
  Envoyer: 'Senda',
  Imprimer: 'Prenta',
  Retour: 'Til baka',
  Nouveau: 'Nýtt',
  Rechercher: 'Leita',
  Date: 'Dagsetning',
  Client: 'Viðskiptavinur',
  Total: 'Samtals',
  TVA: 'VSK',
  Statut: 'Staða',
  Payée: 'Greitt',
  Envoyée: 'Sent',
  'En attente': 'Bíður',
  Brouillon: 'Drög',
  Terminé: 'Lokið',
};
I18N.el = {
  Accueil: 'Αρχική',
  Ventes: 'Πωλήσεις',
  Offres: 'Προσφορές',
  Devis: 'Προσφορά',
  Chantiers: 'Εργοτάξια',
  Factures: 'Τιμολόγια',
  Équipe: 'Ομάδα',
  Plus: 'Περισσότερα',
  Comptabilité: 'Λογιστική',
  Stock: 'Απόθεμα',
  Clients: 'Πελάτες',
  'Rendez-vous': 'Ραντεβού',
  Planning: 'Προγραμματισμός',
  Commandes: 'Παραγγελίες',
  Livraisons: 'Παραδόσεις',
  Remises: 'Εκπτώσεις',
  Notifications: 'Ειδοποιήσεις',
  Réglages: 'Ρυθμίσεις',
  Dépenses: 'Έξοδα',
  Enregistrer: 'Αποθήκευση',
  Annuler: 'Ακύρωση',
  Ajouter: 'Προσθήκη',
  Envoyer: 'Αποστολή',
  Imprimer: 'Εκτύπωση',
  Retour: 'Πίσω',
  Nouveau: 'Νέο',
  Rechercher: 'Αναζήτηση',
  Date: 'Ημερομηνία',
  Client: 'Πελάτης',
  Total: 'Σύνολο',
  TVA: 'ΦΠΑ',
  Statut: 'Κατάσταση',
  Payée: 'Πληρωμένο',
  Envoyée: 'Απεσταλμένο',
  'En attente': 'Σε αναμονή',
  Brouillon: 'Πρόχειρο',
  Terminé: 'Ολοκληρώθηκε',
};
I18N.bg = {
  Accueil: 'Начало',
  Ventes: 'Продажби',
  Offres: 'Оферти',
  Devis: 'Оферта',
  Chantiers: 'Обекти',
  Factures: 'Фактури',
  Équipe: 'Екип',
  Plus: 'Още',
  Comptabilité: 'Счетоводство',
  Stock: 'Склад',
  Clients: 'Клиенти',
  'Rendez-vous': 'Срещи',
  Planning: 'Планиране',
  Commandes: 'Поръчки',
  Livraisons: 'Доставки',
  Remises: 'Отстъпки',
  Notifications: 'Известия',
  Réglages: 'Настройки',
  Dépenses: 'Разходи',
  Enregistrer: 'Запази',
  Annuler: 'Отказ',
  Ajouter: 'Добави',
  Envoyer: 'Изпрати',
  Imprimer: 'Печат',
  Retour: 'Назад',
  Nouveau: 'Нов',
  Rechercher: 'Търсене',
  Date: 'Дата',
  Client: 'Клиент',
  Total: 'Общо',
  TVA: 'ДДС',
  Statut: 'Статус',
  Payée: 'Платена',
  Envoyée: 'Изпратена',
  'En attente': 'Изчакване',
  Brouillon: 'Чернова',
  Terminé: 'Завършено',
};
I18N.ru = {
  Accueil: 'Главная',
  Ventes: 'Продажи',
  Offres: 'Предложения',
  Devis: 'Смета',
  Chantiers: 'Объекты',
  Factures: 'Счета',
  Équipe: 'Команда',
  Plus: 'Ещё',
  Comptabilité: 'Бухгалтерия',
  Stock: 'Склад',
  Clients: 'Клиенты',
  'Rendez-vous': 'Встречи',
  Planning: 'Планирование',
  Commandes: 'Заказы',
  Livraisons: 'Доставки',
  Remises: 'Скидки',
  Notifications: 'Уведомления',
  Réglages: 'Настройки',
  Dépenses: 'Расходы',
  Enregistrer: 'Сохранить',
  Annuler: 'Отмена',
  Ajouter: 'Добавить',
  Envoyer: 'Отправить',
  Imprimer: 'Печать',
  Retour: 'Назад',
  Nouveau: 'Новый',
  Rechercher: 'Поиск',
  Date: 'Дата',
  Client: 'Клиент',
  Total: 'Итого',
  TVA: 'НДС',
  Statut: 'Статус',
  Payée: 'Оплачено',
  Envoyée: 'Отправлено',
  'En attente': 'Ожидание',
  Brouillon: 'Черновик',
  Terminé: 'Завершено',
};
I18N.uk = {
  Accueil: 'Головна',
  Ventes: 'Продажі',
  Offres: 'Пропозиції',
  Devis: 'Кошторис',
  Chantiers: 'Обєкти',
  Factures: 'Рахунки',
  Équipe: 'Команда',
  Plus: 'Більше',
  Comptabilité: 'Бухгалтерія',
  Stock: 'Склад',
  Clients: 'Клієнти',
  'Rendez-vous': 'Зустрічі',
  Planning: 'Планування',
  Commandes: 'Замовлення',
  Livraisons: 'Доставки',
  Remises: 'Знижки',
  Notifications: 'Сповіщення',
  Réglages: 'Налаштування',
  Dépenses: 'Витрати',
  Enregistrer: 'Зберегти',
  Annuler: 'Скасувати',
  Ajouter: 'Додати',
  Envoyer: 'Надіслати',
  Imprimer: 'Друк',
  Retour: 'Назад',
  Nouveau: 'Новий',
  Rechercher: 'Пошук',
  Date: 'Дата',
  Client: 'Клієнт',
  Total: 'Разом',
  TVA: 'ПДВ',
  Statut: 'Статус',
  Payée: 'Оплачено',
  Envoyée: 'Надіслано',
  'En attente': 'Очікування',
  Brouillon: 'Чернетка',
  Terminé: 'Завершено',
};
I18N.sr = {
  Accueil: 'Početna',
  Ventes: 'Prodaja',
  Offres: 'Ponude',
  Devis: 'Ponuda',
  Chantiers: 'Gradilišta',
  Factures: 'Računi',
  Équipe: 'Tim',
  Plus: 'Više',
  Comptabilité: 'Računovodstvo',
  Stock: 'Zalihe',
  Clients: 'Klijenti',
  'Rendez-vous': 'Sastanci',
  Planning: 'Planiranje',
  Commandes: 'Porudžbine',
  Livraisons: 'Isporuke',
  Remises: 'Popusti',
  Notifications: 'Obaveštenja',
  Réglages: 'Podešavanja',
  Dépenses: 'Troškovi',
  Enregistrer: 'Sačuvaj',
  Annuler: 'Otkaži',
  Ajouter: 'Dodaj',
  Envoyer: 'Pošalji',
  Imprimer: 'Štampaj',
  Retour: 'Nazad',
  Nouveau: 'Novo',
  Rechercher: 'Pretraga',
  Date: 'Datum',
  Client: 'Klijent',
  Total: 'Ukupno',
  TVA: 'PDV',
  Statut: 'Status',
  Payée: 'Plaćeno',
  Envoyée: 'Poslato',
  'En attente': 'Na čekanju',
  Brouillon: 'Nacrt',
  Terminé: 'Završeno',
};
I18N.mk = {
  Accueil: 'Почетна',
  Ventes: 'Продажба',
  Offres: 'Понуди',
  Devis: 'Понуда',
  Chantiers: 'Градилишта',
  Factures: 'Фактури',
  Équipe: 'Тим',
  Plus: 'Повеќе',
  Comptabilité: 'Сметководство',
  Stock: 'Залиха',
  Clients: 'Клиенти',
  'Rendez-vous': 'Состаноци',
  Planning: 'Планирање',
  Commandes: 'Нарачки',
  Livraisons: 'Испораки',
  Remises: 'Попусти',
  Notifications: 'Известувања',
  Réglages: 'Поставки',
  Dépenses: 'Трошоци',
  Enregistrer: 'Зачувај',
  Annuler: 'Откажи',
  Ajouter: 'Додај',
  Envoyer: 'Испрати',
  Imprimer: 'Печати',
  Retour: 'Назад',
  Nouveau: 'Ново',
  Rechercher: 'Пребарување',
  Date: 'Датум',
  Client: 'Клиент',
  Total: 'Вкупно',
  TVA: 'ДДВ',
  Statut: 'Статус',
  Payée: 'Платено',
  Envoyée: 'Испратено',
  'En attente': 'Во исчекување',
  Brouillon: 'Нацрт',
  Terminé: 'Завршено',
};
I18N.tr = {
  Accueil: 'Ana sayfa',
  Ventes: 'Satışlar',
  Offres: 'Teklifler',
  Devis: 'Teklif',
  Chantiers: 'Şantiyeler',
  Factures: 'Faturalar',
  Équipe: 'Ekip',
  Plus: 'Daha fazla',
  Comptabilité: 'Muhasebe',
  Stock: 'Stok',
  Clients: 'Müşteriler',
  'Rendez-vous': 'Randevular',
  Planning: 'Planlama',
  Commandes: 'Siparişler',
  Livraisons: 'Teslimatlar',
  Remises: 'İndirimler',
  Notifications: 'Bildirimler',
  Réglages: 'Ayarlar',
  Dépenses: 'Giderler',
  Enregistrer: 'Kaydet',
  Annuler: 'İptal',
  Ajouter: 'Ekle',
  Envoyer: 'Gönder',
  Imprimer: 'Yazdır',
  Retour: 'Geri',
  Nouveau: 'Yeni',
  Rechercher: 'Ara',
  Date: 'Tarih',
  Client: 'Müşteri',
  Total: 'Toplam',
  TVA: 'KDV',
  Statut: 'Durum',
  Payée: 'Ödendi',
  Envoyée: 'Gönderildi',
  'En attente': 'Beklemede',
  Brouillon: 'Taslak',
  Terminé: 'Tamamlandı',
};
I18N.ar = {
  Accueil: 'الرئيسية',
  Ventes: 'المبيعات',
  Offres: 'عروض الأسعار',
  Devis: 'عرض سعر',
  Chantiers: 'المواقع',
  Factures: 'الفواتير',
  Équipe: 'الفريق',
  Plus: 'المزيد',
  Comptabilité: 'المحاسبة',
  Stock: 'المخزون',
  Clients: 'العملاء',
  'Rendez-vous': 'المواعيد',
  Planning: 'التخطيط',
  Commandes: 'الطلبات',
  Livraisons: 'التسليمات',
  Remises: 'الخصومات',
  Notifications: 'الإشعارات',
  Réglages: 'الإعدادات',
  Dépenses: 'المصاريف',
  Enregistrer: 'حفظ',
  Annuler: 'إلغاء',
  Ajouter: 'إضافة',
  Envoyer: 'إرسال',
  Imprimer: 'طباعة',
  Retour: 'رجوع',
  Nouveau: 'جديد',
  Rechercher: 'بحث',
  Date: 'التاريخ',
  Client: 'العميل',
  Total: 'المجموع',
  TVA: 'ضريبة',
  Statut: 'الحالة',
  Payée: 'مدفوعة',
  Envoyée: 'مرسلة',
  'En attente': 'قيد الانتظار',
  Brouillon: 'مسودة',
  Terminé: 'مكتمل',
};
I18N.zh = {
  Accueil: '主页',
  Ventes: '销售',
  Offres: '报价',
  Devis: '报价单',
  Chantiers: '工地',
  Factures: '发票',
  Équipe: '团队',
  Plus: '更多',
  Comptabilité: '会计',
  Stock: '库存',
  Clients: '客户',
  'Rendez-vous': '预约',
  Planning: '计划',
  Commandes: '订单',
  Livraisons: '交付',
  Remises: '折扣',
  Notifications: '通知',
  Réglages: '设置',
  Dépenses: '支出',
  Enregistrer: '保存',
  Annuler: '取消',
  Ajouter: '添加',
  Envoyer: '发送',
  Imprimer: '打印',
  Retour: '返回',
  Nouveau: '新建',
  Rechercher: '搜索',
  Date: '日期',
  Client: '客户',
  Total: '合计',
  TVA: '增值税',
  Statut: '状态',
  Payée: '已付款',
  Envoyée: '已发送',
  'En attente': '待处理',
  Brouillon: '草稿',
  Terminé: '已完成',
};
I18N.ja = {
  Accueil: 'ホーム',
  Ventes: '売上',
  Offres: '見積',
  Devis: '見積書',
  Chantiers: '現場',
  Factures: '請求書',
  Équipe: 'チーム',
  Plus: 'その他',
  Comptabilité: '会計',
  Stock: '在庫',
  Clients: '顧客',
  'Rendez-vous': '予約',
  Planning: '計画',
  Commandes: '注文',
  Livraisons: '配送',
  Remises: '割引',
  Notifications: '通知',
  Réglages: '設定',
  Dépenses: '経費',
  Enregistrer: '保存',
  Annuler: 'キャンセル',
  Ajouter: '追加',
  Envoyer: '送信',
  Imprimer: '印刷',
  Retour: '戻る',
  Nouveau: '新規',
  Rechercher: '検索',
  Date: '日付',
  Client: '顧客',
  Total: '合計',
  TVA: '消費税',
  Statut: '状態',
  Payée: '支払済',
  Envoyée: '送信済',
  'En attente': '保留中',
  Brouillon: '下書き',
  Terminé: '完了',
};
I18N.ko = {
  Accueil: '홈',
  Ventes: '판매',
  Offres: '견적',
  Devis: '견적서',
  Chantiers: '현장',
  Factures: '청구서',
  Équipe: '팀',
  Plus: '더보기',
  Comptabilité: '회계',
  Stock: '재고',
  Clients: '고객',
  'Rendez-vous': '약속',
  Planning: '계획',
  Commandes: '주문',
  Livraisons: '배송',
  Remises: '할인',
  Notifications: '알림',
  Réglages: '설정',
  Dépenses: '지출',
  Enregistrer: '저장',
  Annuler: '취소',
  Ajouter: '추가',
  Envoyer: '보내기',
  Imprimer: '인쇄',
  Retour: '뒤로',
  Nouveau: '새로',
  Rechercher: '검색',
  Date: '날짜',
  Client: '고객',
  Total: '합계',
  TVA: '부가세',
  Statut: '상태',
  Payée: '결제됨',
  Envoyée: '전송됨',
  'En attente': '대기중',
  Brouillon: '초안',
  Terminé: '완료',
};
I18N.hi = {
  Accueil: 'होम',
  Ventes: 'बिक्री',
  Offres: 'कोटेशन',
  Devis: 'कोटेशन',
  Chantiers: 'साइट',
  Factures: 'चालान',
  Équipe: 'टीम',
  Plus: 'और',
  Comptabilité: 'लेखांकन',
  Stock: 'स्टॉक',
  Clients: 'ग्राहक',
  'Rendez-vous': 'अपॉइंटमेंट',
  Planning: 'योजना',
  Commandes: 'ऑर्डर',
  Livraisons: 'डिलीवरी',
  Remises: 'छूट',
  Notifications: 'सूचनाएं',
  Réglages: 'सेटिंग्स',
  Dépenses: 'खर्च',
  Enregistrer: 'सहेजें',
  Annuler: 'रद्द करें',
  Ajouter: 'जोड़ें',
  Envoyer: 'भेजें',
  Imprimer: 'प्रिंट करें',
  Retour: 'वापस',
  Nouveau: 'नया',
  Rechercher: 'खोजें',
  Date: 'तारीख',
  Client: 'ग्राहक',
  Total: 'कुल',
  TVA: 'जीएसटी',
  Statut: 'स्थिति',
  Payée: 'भुगतान किया',
  Envoyée: 'भेजा गया',
  'En attente': 'लंबित',
  Brouillon: 'ड्राफ्ट',
  Terminé: 'पूर्ण',
};
I18N.id = {
  Accueil: 'Beranda',
  Ventes: 'Penjualan',
  Offres: 'Penawaran',
  Devis: 'Penawaran',
  Chantiers: 'Proyek',
  Factures: 'Faktur',
  Équipe: 'Tim',
  Plus: 'Lainnya',
  Comptabilité: 'Akuntansi',
  Stock: 'Stok',
  Clients: 'Pelanggan',
  'Rendez-vous': 'Janji temu',
  Planning: 'Perencanaan',
  Commandes: 'Pesanan',
  Livraisons: 'Pengiriman',
  Remises: 'Diskon',
  Notifications: 'Notifikasi',
  Réglages: 'Pengaturan',
  Dépenses: 'Pengeluaran',
  Enregistrer: 'Simpan',
  Annuler: 'Batal',
  Ajouter: 'Tambah',
  Envoyer: 'Kirim',
  Imprimer: 'Cetak',
  Retour: 'Kembali',
  Nouveau: 'Baru',
  Rechercher: 'Cari',
  Date: 'Tanggal',
  Client: 'Pelanggan',
  Total: 'Total',
  TVA: 'PPN',
  Statut: 'Status',
  Payée: 'Dibayar',
  Envoyée: 'Terkirim',
  'En attente': 'Menunggu',
  Brouillon: 'Draf',
  Terminé: 'Selesai',
};
I18N.vi = {
  Accueil: 'Trang chủ',
  Ventes: 'Bán hàng',
  Offres: 'Báo giá',
  Devis: 'Báo giá',
  Chantiers: 'Công trình',
  Factures: 'Hóa đơn',
  Équipe: 'Nhóm',
  Plus: 'Thêm',
  Comptabilité: 'Kế toán',
  Stock: 'Kho',
  Clients: 'Khách hàng',
  'Rendez-vous': 'Cuộc hẹn',
  Planning: 'Lập kế hoạch',
  Commandes: 'Đơn hàng',
  Livraisons: 'Giao hàng',
  Remises: 'Giảm giá',
  Notifications: 'Thông báo',
  Réglages: 'Cài đặt',
  Dépenses: 'Chi phí',
  Enregistrer: 'Lưu',
  Annuler: 'Hủy',
  Ajouter: 'Thêm',
  Envoyer: 'Gửi',
  Imprimer: 'In',
  Retour: 'Quay lại',
  Nouveau: 'Mới',
  Rechercher: 'Tìm kiếm',
  Date: 'Ngày',
  Client: 'Khách hàng',
  Total: 'Tổng',
  TVA: 'VAT',
  Statut: 'Trạng thái',
  Payée: 'Đã thanh toán',
  Envoyée: 'Đã gửi',
  'En attente': 'Đang chờ',
  Brouillon: 'Bản nháp',
  Terminé: 'Hoàn thành',
};
I18N.th = {
  Accueil: 'หน้าแรก',
  Ventes: 'การขาย',
  Offres: 'ใบเสนอราคา',
  Devis: 'ใบเสนอราคา',
  Chantiers: 'ไซต์งาน',
  Factures: 'ใบแจ้งหนี้',
  Équipe: 'ทีม',
  Plus: 'เพิ่มเติม',
  Comptabilité: 'บัญชี',
  Stock: 'สต็อก',
  Clients: 'ลูกค้า',
  'Rendez-vous': 'นัดหมาย',
  Planning: 'การวางแผน',
  Commandes: 'คำสั่งซื้อ',
  Livraisons: 'การจัดส่ง',
  Remises: 'ส่วนลด',
  Notifications: 'การแจ้งเตือน',
  Réglages: 'การตั้งค่า',
  Dépenses: 'ค่าใช้จ่าย',
  Enregistrer: 'บันทึก',
  Annuler: 'ยกเลิก',
  Ajouter: 'เพิ่ม',
  Envoyer: 'ส่ง',
  Imprimer: 'พิมพ์',
  Retour: 'กลับ',
  Nouveau: 'ใหม่',
  Rechercher: 'ค้นหา',
  Date: 'วันที่',
  Client: 'ลูกค้า',
  Total: 'รวม',
  TVA: 'ภาษีมูลค่าเพิ่ม',
  Statut: 'สถานะ',
  Payée: 'ชำระแล้ว',
  Envoyée: 'ส่งแล้ว',
  'En attente': 'รอดำเนินการ',
  Brouillon: 'ฉบับร่าง',
  Terminé: 'เสร็จสิ้น',
};
I18N.ms = {
  Accueil: 'Utama',
  Ventes: 'Jualan',
  Offres: 'Sebut harga',
  Devis: 'Sebut harga',
  Chantiers: 'Tapak',
  Factures: 'Invois',
  Équipe: 'Pasukan',
  Plus: 'Lagi',
  Comptabilité: 'Perakaunan',
  Stock: 'Stok',
  Clients: 'Pelanggan',
  'Rendez-vous': 'Janji temu',
  Planning: 'Perancangan',
  Commandes: 'Pesanan',
  Livraisons: 'Penghantaran',
  Remises: 'Diskaun',
  Notifications: 'Pemberitahuan',
  Réglages: 'Tetapan',
  Dépenses: 'Perbelanjaan',
  Enregistrer: 'Simpan',
  Annuler: 'Batal',
  Ajouter: 'Tambah',
  Envoyer: 'Hantar',
  Imprimer: 'Cetak',
  Retour: 'Kembali',
  Nouveau: 'Baharu',
  Rechercher: 'Cari',
  Date: 'Tarikh',
  Client: 'Pelanggan',
  Total: 'Jumlah',
  TVA: 'SST',
  Statut: 'Status',
  Payée: 'Dibayar',
  Envoyée: 'Dihantar',
  'En attente': 'Menunggu',
  Brouillon: 'Draf',
  Terminé: 'Selesai',
};
I18N.tl = {
  Accueil: 'Home',
  Ventes: 'Benta',
  Offres: 'Quote',
  Devis: 'Quote',
  Chantiers: 'Site',
  Factures: 'Mga invoice',
  Équipe: 'Koponan',
  Plus: 'Higit pa',
  Comptabilité: 'Accounting',
  Stock: 'Stock',
  Clients: 'Mga kliyente',
  'Rendez-vous': 'Mga appointment',
  Planning: 'Pagpaplano',
  Commandes: 'Mga order',
  Livraisons: 'Mga delivery',
  Remises: 'Mga diskwento',
  Notifications: 'Mga abiso',
  Réglages: 'Mga setting',
  Dépenses: 'Mga gastos',
  Enregistrer: 'I-save',
  Annuler: 'Kanselahin',
  Ajouter: 'Magdagdag',
  Envoyer: 'Ipadala',
  Imprimer: 'I-print',
  Retour: 'Bumalik',
  Nouveau: 'Bago',
  Rechercher: 'Maghanap',
  Date: 'Petsa',
  Client: 'Kliyente',
  Total: 'Kabuuan',
  TVA: 'VAT',
  Statut: 'Status',
  Payée: 'Bayad',
  Envoyée: 'Naipadala',
  'En attente': 'Naghihintay',
  Brouillon: 'Draft',
  Terminé: 'Tapos',
};
I18N.fa = {
  Accueil: 'خانه',
  Ventes: 'فروش',
  Offres: 'پیش‌فاکتور',
  Devis: 'پیش‌فاکتور',
  Chantiers: 'پروژه‌ها',
  Factures: 'فاکتورها',
  Équipe: 'تیم',
  Plus: 'بیشتر',
  Comptabilité: 'حسابداری',
  Stock: 'انبار',
  Clients: 'مشتریان',
  'Rendez-vous': 'قرار ملاقات',
  Planning: 'برنامه‌ریزی',
  Commandes: 'سفارش‌ها',
  Livraisons: 'تحویل',
  Remises: 'تخفیف‌ها',
  Notifications: 'اعلان‌ها',
  Réglages: 'تنظیمات',
  Dépenses: 'هزینه‌ها',
  Enregistrer: 'ذخیره',
  Annuler: 'لغو',
  Ajouter: 'افزودن',
  Envoyer: 'ارسال',
  Imprimer: 'چاپ',
  Retour: 'بازگشت',
  Nouveau: 'جدید',
  Rechercher: 'جستجو',
  Date: 'تاریخ',
  Client: 'مشتری',
  Total: 'مجموع',
  TVA: 'مالیات',
  Statut: 'وضعیت',
  Payée: 'پرداخت شده',
  Envoyée: 'ارسال شده',
  'En attente': 'در انتظار',
  Brouillon: 'پیش‌نویس',
  Terminé: 'تکمیل شده',
};
I18N.ur = {
  Accueil: 'ہوم',
  Ventes: 'فروخت',
  Offres: 'کوٹیشن',
  Devis: 'کوٹیشن',
  Chantiers: 'سائٹس',
  Factures: 'انوائسز',
  Équipe: 'ٹیم',
  Plus: 'مزید',
  Comptabilité: 'اکاؤنٹنگ',
  Stock: 'اسٹاک',
  Clients: 'گاہک',
  'Rendez-vous': 'ملاقاتیں',
  Planning: 'منصوبہ بندی',
  Commandes: 'آرڈرز',
  Livraisons: 'ترسیل',
  Remises: 'رعایتیں',
  Notifications: 'اطلاعات',
  Réglages: 'ترتیبات',
  Dépenses: 'اخراجات',
  Enregistrer: 'محفوظ کریں',
  Annuler: 'منسوخ کریں',
  Ajouter: 'شامل کریں',
  Envoyer: 'بھیجیں',
  Imprimer: 'پرنٹ کریں',
  Retour: 'واپس',
  Nouveau: 'نیا',
  Rechercher: 'تلاش کریں',
  Date: 'تاریخ',
  Client: 'گاہک',
  Total: 'کل',
  TVA: 'ٹیکس',
  Statut: 'حیثیت',
  Payée: 'ادا شدہ',
  Envoyée: 'بھیج دیا',
  'En attente': 'زیر التواء',
  Brouillon: 'مسودہ',
  Terminé: 'مکمل',
};
I18N.he = {
  Accueil: 'בית',
  Ventes: 'מכירות',
  Offres: 'הצעות מחיר',
  Devis: 'הצעת מחיר',
  Chantiers: 'אתרים',
  Factures: 'חשבוניות',
  Équipe: 'צוות',
  Plus: 'עוד',
  Comptabilité: 'הנהלת חשבונות',
  Stock: 'מלאי',
  Clients: 'לקוחות',
  'Rendez-vous': 'פגישות',
  Planning: 'תכנון',
  Commandes: 'הזמנות',
  Livraisons: 'משלוחים',
  Remises: 'הנחות',
  Notifications: 'התראות',
  Réglages: 'הגדרות',
  Dépenses: 'הוצאות',
  Enregistrer: 'שמור',
  Annuler: 'בטל',
  Ajouter: 'הוסף',
  Envoyer: 'שלח',
  Imprimer: 'הדפס',
  Retour: 'חזור',
  Nouveau: 'חדש',
  Rechercher: 'חיפוש',
  Date: 'תאריך',
  Client: 'לקוח',
  Total: 'סך הכל',
  TVA: 'מע״מ',
  Statut: 'סטטוס',
  Payée: 'שולם',
  Envoyée: 'נשלח',
  'En attente': 'ממתין',
  Brouillon: 'טיוטה',
  Terminé: 'הושלם',
};
I18N.sw = {
  Accueil: 'Mwanzo',
  Ventes: 'Mauzo',
  Offres: 'Nukuu',
  Devis: 'Nukuu',
  Chantiers: 'Tovuti',
  Factures: 'Ankara',
  Équipe: 'Timu',
  Plus: 'Zaidi',
  Comptabilité: 'Uhasibu',
  Stock: 'Hisa',
  Clients: 'Wateja',
  'Rendez-vous': 'Miadi',
  Planning: 'Mipango',
  Commandes: 'Maagizo',
  Livraisons: 'Uwasilishaji',
  Remises: 'Punguzo',
  Notifications: 'Arifa',
  Réglages: 'Mipangilio',
  Dépenses: 'Matumizi',
  Enregistrer: 'Hifadhi',
  Annuler: 'Ghairi',
  Ajouter: 'Ongeza',
  Envoyer: 'Tuma',
  Imprimer: 'Chapisha',
  Retour: 'Rudi',
  Nouveau: 'Mpya',
  Rechercher: 'Tafuta',
  Date: 'Tarehe',
  Client: 'Mteja',
  Total: 'Jumla',
  TVA: 'VAT',
  Statut: 'Hali',
  Payée: 'Imelipwa',
  Envoyée: 'Imetumwa',
  'En attente': 'Inasubiri',
  Brouillon: 'Rasimu',
  Terminé: 'Imekamilika',
};
Object.assign(I18N.en, {
  Enregistrer: 'Save',
  Annuler: 'Cancel',
  Ajouter: 'Add',
  Continuer: 'Continue',
  Commencer: 'Start',
  Fermer: 'Close',
  Modifier: 'Edit',
  Supprimer: 'Delete',
  Valider: 'Confirm',
  Envoyer: 'Send',
  Imprimer: 'Print',
  Partager: 'Share',
  Retour: 'Back',
  Suivant: 'Next',
  Nouveau: 'New',
  Rechercher: 'Search',
  Date: 'Date',
  Client: 'Client',
  Adresse: 'Address',
  Description: 'Description',
  Désignation: 'Description',
  Quantité: 'Quantity',
  Prix: 'Price',
  Unité: 'Unit',
  Total: 'Total',
  Référence: 'Reference',
  Catégorie: 'Category',
  Banque: 'Bank',
  Caisse: 'Cash',
  Délai: 'Deadline',
  Notes: 'Notes',
  Photo: 'Photo',
  Acompte: 'Deposit',
  Solde: 'Balance',
  Remise: 'Discount',
  TVA: 'VAT',
  'Sous-total': 'Subtotal',
  Échéance: 'Due date',
  Statut: 'Status',
  Téléphone: 'Phone',
  Email: 'Email',
  Nom: 'Name',
  Prénom: 'First name',
  Société: 'Company',
  Signature: 'Signature',
  Heures: 'Hours',
  Salaire: 'Salary',
  Employé: 'Employee',
  Fournisseur: 'Supplier',
  Vente: 'Sale',
  Ticket: 'Receipt',
  'Enregistré !': 'Saved!',
});
Object.assign(I18N.de, {
  Enregistrer: 'Speichern',
  Annuler: 'Abbrechen',
  Ajouter: 'Hinzufügen',
  Continuer: 'Weiter',
  Commencer: 'Starten',
  Fermer: 'Schliessen',
  Modifier: 'Bearbeiten',
  Supprimer: 'Löschen',
  Valider: 'Bestätigen',
  Envoyer: 'Senden',
  Imprimer: 'Drucken',
  Partager: 'Teilen',
  Retour: 'Zurück',
  Suivant: 'Weiter',
  Nouveau: 'Neu',
  Rechercher: 'Suchen',
  Date: 'Datum',
  Client: 'Kunde',
  Adresse: 'Adresse',
  Description: 'Beschreibung',
  Désignation: 'Bezeichnung',
  Quantité: 'Menge',
  Prix: 'Preis',
  Unité: 'Einheit',
  Total: 'Total',
  Référence: 'Referenz',
  Catégorie: 'Kategorie',
  Banque: 'Bank',
  Caisse: 'Kasse',
  Délai: 'Frist',
  Notes: 'Notizen',
  Photo: 'Foto',
  Acompte: 'Anzahlung',
  Solde: 'Restbetrag',
  Remise: 'Rabatt',
  TVA: 'MwSt',
  'Sous-total': 'Zwischensumme',
  Échéance: 'Fälligkeit',
  Statut: 'Status',
  Téléphone: 'Telefon',
  Email: 'E-Mail',
  Nom: 'Name',
  Prénom: 'Vorname',
  Société: 'Firma',
  Signature: 'Unterschrift',
  Heures: 'Stunden',
  Salaire: 'Lohn',
  Employé: 'Mitarbeiter',
  Fournisseur: 'Lieferant',
  Vente: 'Verkauf',
  Ticket: 'Beleg',
  'Enregistré !': 'Gespeichert!',
});
Object.assign(I18N.it, {
  Enregistrer: 'Salva',
  Annuler: 'Annulla',
  Ajouter: 'Aggiungi',
  Continuer: 'Continua',
  Commencer: 'Inizia',
  Fermer: 'Chiudi',
  Modifier: 'Modifica',
  Supprimer: 'Elimina',
  Valider: 'Conferma',
  Envoyer: 'Invia',
  Imprimer: 'Stampa',
  Partager: 'Condividi',
  Retour: 'Indietro',
  Suivant: 'Avanti',
  Nouveau: 'Nuovo',
  Rechercher: 'Cerca',
  Date: 'Data',
  Client: 'Cliente',
  Adresse: 'Indirizzo',
  Description: 'Descrizione',
  Désignation: 'Designazione',
  Quantité: 'Quantità',
  Prix: 'Prezzo',
  Unité: 'Unità',
  Total: 'Totale',
  Référence: 'Riferimento',
  Catégorie: 'Categoria',
  Banque: 'Banca',
  Caisse: 'Cassa',
  Délai: 'Termine',
  Notes: 'Note',
  Photo: 'Foto',
  Acompte: 'Acconto',
  Solde: 'Saldo',
  Remise: 'Sconto',
  TVA: 'IVA',
  'Sous-total': 'Subtotale',
  Échéance: 'Scadenza',
  Statut: 'Stato',
  Téléphone: 'Telefono',
  Email: 'Email',
  Nom: 'Nome',
  Prénom: 'Nome',
  Société: 'Azienda',
  Signature: 'Firma',
  Heures: 'Ore',
  Salaire: 'Stipendio',
  Employé: 'Dipendente',
  Fournisseur: 'Fornitore',
  Vente: 'Vendita',
  Ticket: 'Scontrino',
  'Enregistré !': 'Salvato!',
});
Object.assign(I18N.es, {
  Enregistrer: 'Guardar',
  Annuler: 'Cancelar',
  Ajouter: 'Añadir',
  Continuer: 'Continuar',
  Commencer: 'Empezar',
  Fermer: 'Cerrar',
  Modifier: 'Editar',
  Supprimer: 'Eliminar',
  Valider: 'Confirmar',
  Envoyer: 'Enviar',
  Imprimer: 'Imprimir',
  Partager: 'Compartir',
  Retour: 'Volver',
  Suivant: 'Siguiente',
  Nouveau: 'Nuevo',
  Rechercher: 'Buscar',
  Date: 'Fecha',
  Client: 'Cliente',
  Adresse: 'Dirección',
  Description: 'Descripción',
  Désignation: 'Designación',
  Quantité: 'Cantidad',
  Prix: 'Precio',
  Unité: 'Unidad',
  Total: 'Total',
  Référence: 'Referencia',
  Catégorie: 'Categoría',
  Banque: 'Banco',
  Caisse: 'Caja',
  Délai: 'Plazo',
  Notes: 'Notas',
  Photo: 'Foto',
  Acompte: 'Anticipo',
  Solde: 'Saldo',
  Remise: 'Descuento',
  TVA: 'IVA',
  'Sous-total': 'Subtotal',
  Échéance: 'Vencimiento',
  Statut: 'Estado',
  Téléphone: 'Teléfono',
  Email: 'Email',
  Nom: 'Nombre',
  Prénom: 'Nombre',
  Société: 'Empresa',
  Signature: 'Firma',
  Heures: 'Horas',
  Salaire: 'Salario',
  Employé: 'Empleado',
  Fournisseur: 'Proveedor',
  Vente: 'Venta',
  Ticket: 'Recibo',
  'Enregistré !': '¡Guardado!',
});
Object.assign(I18N.en, {
  Destinataire: 'Recipient',
  "Délai d'exécution": 'Lead time',
  'Description des travaux': 'Work description',
  'Coordonnées bancaires': 'Bank details',
  'Facture fournisseur': 'Supplier invoice',
  'Décompte TVA': 'VAT statement',
  'Compte de résultat': 'Income statement',
  'Bilan simplifié': 'Simplified balance sheet',
  'Grand livre / Journal': 'General ledger / Journal',
  Fonction: 'Position',
  Fréquence: 'Frequency',
  Heure: 'Time',
  "Chiffre d'affaires": 'Turnover',
  'Bénéfice net': 'Net profit',
  'Coût total employeur': 'Total employer cost',
  'Déductions sociales': 'Social deductions',
  Du: 'From',
  Au: 'To',
  Détails: 'Details',
  Affichage: 'Display',
  Alertes: 'Alerts',
  Entreprise: 'Company',
  Entrée: 'Entry',
  Sortie: 'Exit',
  'Compte client': 'Customer account',
  'Congés en attente': 'Pending leave',
  'Demander des congés': 'Request leave',
  'Couleur des documents': 'Document color',
  'Corps de métier': 'Trade',
  'Fonds propres': 'Equity',
  "Frais & charges d'exploitation": 'Operating expenses',
  'Fiche de salaire': 'Payslip',
  'Caisse du jour': "Today's cash",
  'Facturation client': 'Client billing',
  'Description & conditions': 'Description & terms',
  'Client & articles': 'Client & items',
});
Object.assign(I18N.de, {
  Destinataire: 'Empfänger',
  "Délai d'exécution": 'Ausführungsfrist',
  'Description des travaux': 'Arbeitsbeschreibung',
  'Coordonnées bancaires': 'Bankverbindung',
  'Facture fournisseur': 'Lieferantenrechnung',
  'Décompte TVA': 'MwSt-Abrechnung',
  'Compte de résultat': 'Erfolgsrechnung',
  'Bilan simplifié': 'Vereinfachte Bilanz',
  'Grand livre / Journal': 'Hauptbuch / Journal',
  Fonction: 'Funktion',
  Fréquence: 'Häufigkeit',
  Heure: 'Zeit',
  "Chiffre d'affaires": 'Umsatz',
  'Bénéfice net': 'Reingewinn',
  'Coût total employeur': 'Arbeitgeberkosten total',
  'Déductions sociales': 'Sozialabzüge',
  Du: 'Von',
  Au: 'Bis',
  Détails: 'Details',
  Affichage: 'Anzeige',
  Alertes: 'Warnungen',
  Entreprise: 'Unternehmen',
  Entrée: 'Eingang',
  Sortie: 'Ausgang',
  'Compte client': 'Kundenkonto',
  'Congés en attente': 'Offene Ferien',
  'Demander des congés': 'Ferien beantragen',
  'Couleur des documents': 'Dokumentfarbe',
  'Corps de métier': 'Beruf',
  'Fonds propres': 'Eigenkapital',
  "Frais & charges d'exploitation": 'Betriebsaufwand',
  'Fiche de salaire': 'Lohnabrechnung',
  'Caisse du jour': 'Tageskasse',
  'Facturation client': 'Kundenfakturierung',
  'Description & conditions': 'Beschreibung & Bedingungen',
  'Client & articles': 'Kunde & Artikel',
});
Object.assign(I18N.it, {
  Destinataire: 'Destinatario',
  "Délai d'exécution": 'Tempi di esecuzione',
  'Description des travaux': 'Descrizione dei lavori',
  'Coordonnées bancaires': 'Coordinate bancarie',
  'Facture fournisseur': 'Fattura fornitore',
  'Décompte TVA': 'Rendiconto IVA',
  'Compte de résultat': 'Conto economico',
  'Bilan simplifié': 'Bilancio semplificato',
  'Grand livre / Journal': 'Libro mastro / Giornale',
  Fonction: 'Funzione',
  Fréquence: 'Frequenza',
  Heure: 'Ora',
  "Chiffre d'affaires": 'Fatturato',
  'Bénéfice net': 'Utile netto',
  'Coût total employeur': 'Costo totale datore',
  'Déductions sociales': 'Detrazioni sociali',
  Du: 'Dal',
  Au: 'Al',
  Détails: 'Dettagli',
  Affichage: 'Visualizzazione',
  Alertes: 'Avvisi',
  Entreprise: 'Azienda',
  Entrée: 'Entrata',
  Sortie: 'Uscita',
  'Compte client': 'Conto cliente',
  'Congés en attente': 'Ferie in attesa',
  'Demander des congés': 'Richiedi ferie',
  'Couleur des documents': 'Colore dei documenti',
  'Corps de métier': 'Mestiere',
  'Fonds propres': 'Capitale proprio',
  "Frais & charges d'exploitation": "Costi d'esercizio",
  'Fiche de salaire': 'Busta paga',
  'Caisse du jour': 'Cassa del giorno',
  'Facturation client': 'Fatturazione cliente',
  'Description & conditions': 'Descrizione & condizioni',
  'Client & articles': 'Cliente & articoli',
});
Object.assign(I18N.es, {
  Destinataire: 'Destinatario',
  "Délai d'exécution": 'Plazo de ejecución',
  'Description des travaux': 'Descripción de trabajos',
  'Coordonnées bancaires': 'Datos bancarios',
  'Facture fournisseur': 'Factura de proveedor',
  'Décompte TVA': 'Liquidación de IVA',
  'Compte de résultat': 'Cuenta de resultados',
  'Bilan simplifié': 'Balance simplificado',
  'Grand livre / Journal': 'Libro mayor / Diario',
  Fonction: 'Función',
  Fréquence: 'Frecuencia',
  Heure: 'Hora',
  "Chiffre d'affaires": 'Facturación',
  'Bénéfice net': 'Beneficio neto',
  'Coût total employeur': 'Coste total empleador',
  'Déductions sociales': 'Deducciones sociales',
  Du: 'Del',
  Au: 'Al',
  Détails: 'Detalles',
  Affichage: 'Visualización',
  Alertes: 'Alertas',
  Entreprise: 'Empresa',
  Entrée: 'Entrada',
  Sortie: 'Salida',
  'Compte client': 'Cuenta de cliente',
  'Congés en attente': 'Permisos pendientes',
  'Demander des congés': 'Solicitar permiso',
  'Couleur des documents': 'Color de documentos',
  'Corps de métier': 'Oficio',
  'Fonds propres': 'Fondos propios',
  "Frais & charges d'exploitation": 'Gastos de explotación',
  'Fiche de salaire': 'Nómina',
  'Caisse du jour': 'Caja del día',
  'Facturation client': 'Facturación cliente',
  'Description & conditions': 'Descripción y condiciones',
  'Client & articles': 'Cliente y artículos',
});
Object.assign(I18N.en, {
  Libellé: 'Label',
  Lieu: 'Location',
  Marge: 'Margin',
  'Masse salariale': 'Payroll total',
  Matériaux: 'Materials',
  "Main d'œuvre": 'Labor',
  'Montant HT': 'Amount excl. VAT',
  'Montant TTC': 'Amount incl. VAT',
  'Net à payer': 'Net payable',
  Motif: 'Reason',
  Métier: 'Trade',
  'Mon activité': 'My activity',
  'Mon salaire': 'My salary',
  'Mes rendez-vous': 'My appointments',
  "Mode d'activité": 'Business mode',
  'Modèle des documents': 'Document template',
  'Modèles de messages': 'Message templates',
  'Langue des documents': 'Document language',
  'Informations société': 'Company information',
  'Impayés TTC': 'Unpaid (incl. VAT)',
  'Impayé en cours': 'Outstanding',
  'Encaisser un acompte': 'Collect a deposit',
  'Envoyer la facture au client': 'Send invoice to client',
  'Feuille de présence': 'Attendance sheet',
  'Heures pointées (total)': 'Logged hours (total)',
  'Nombre de jours': 'Number of days',
  'Nom complet': 'Full name',
  'Nom de la prestation': 'Service name',
  'Nous contacter': 'Contact us',
  'Marge commerciale': 'Gross margin',
  'NPA / Localité': 'Zip / City',
  'Mentions légales (CO / SIA)': 'Legal notice (CO / SIA)',
  'Largeur (m)': 'Width (m)',
  'Longueur (m)': 'Length (m)',
  'Jours congés / an': 'Holiday days / year',
  "Lien de l'application": 'App link',
});
Object.assign(I18N.de, {
  Libellé: 'Bezeichnung',
  Lieu: 'Ort',
  Marge: 'Marge',
  'Masse salariale': 'Lohnsumme',
  Matériaux: 'Material',
  "Main d'œuvre": 'Arbeit',
  'Montant HT': 'Betrag exkl. MwSt',
  'Montant TTC': 'Betrag inkl. MwSt',
  'Net à payer': 'Nettobetrag',
  Motif: 'Grund',
  Métier: 'Beruf',
  'Mon activité': 'Meine Tätigkeit',
  'Mon salaire': 'Mein Lohn',
  'Mes rendez-vous': 'Meine Termine',
  "Mode d'activité": 'Betriebsmodus',
  'Modèle des documents': 'Dokumentvorlage',
  'Modèles de messages': 'Nachrichtenvorlagen',
  'Langue des documents': 'Dokumentsprache',
  'Informations société': 'Firmeninformationen',
  'Impayés TTC': 'Offen (inkl. MwSt)',
  'Impayé en cours': 'Ausstehend',
  'Encaisser un acompte': 'Anzahlung kassieren',
  'Envoyer la facture au client': 'Rechnung an Kunde senden',
  'Feuille de présence': 'Anwesenheitsliste',
  'Heures pointées (total)': 'Erfasste Stunden (total)',
  'Nombre de jours': 'Anzahl Tage',
  'Nom complet': 'Vollständiger Name',
  'Nom de la prestation': 'Leistungsname',
  'Nous contacter': 'Kontakt',
  'Marge commerciale': 'Bruttomarge',
  'NPA / Localité': 'PLZ / Ort',
  'Mentions légales (CO / SIA)': 'Rechtliche Hinweise (OR / SIA)',
  'Largeur (m)': 'Breite (m)',
  'Longueur (m)': 'Länge (m)',
  'Jours congés / an': 'Ferientage / Jahr',
  "Lien de l'application": 'App-Link',
});
Object.assign(I18N.it, {
  Libellé: 'Dicitura',
  Lieu: 'Luogo',
  Marge: 'Margine',
  'Masse salariale': 'Monte salari',
  Matériaux: 'Materiali',
  "Main d'œuvre": 'Manodopera',
  'Montant HT': 'Importo IVA escl.',
  'Montant TTC': 'Importo IVA incl.',
  'Net à payer': 'Netto da pagare',
  Motif: 'Motivo',
  Métier: 'Mestiere',
  'Mon activité': 'La mia attività',
  'Mon salaire': 'Il mio stipendio',
  'Mes rendez-vous': 'I miei appuntamenti',
  "Mode d'activité": 'Modalità attività',
  'Modèle des documents': 'Modello documenti',
  'Modèles de messages': 'Modelli di messaggi',
  'Langue des documents': 'Lingua dei documenti',
  'Informations société': 'Informazioni azienda',
  'Impayés TTC': 'Non pagato (IVA incl.)',
  'Impayé en cours': 'In sospeso',
  'Encaisser un acompte': 'Incassa un acconto',
  'Envoyer la facture au client': 'Invia fattura al cliente',
  'Feuille de présence': 'Foglio presenze',
  'Heures pointées (total)': 'Ore registrate (totale)',
  'Nombre de jours': 'Numero di giorni',
  'Nom complet': 'Nome completo',
  'Nom de la prestation': 'Nome prestazione',
  'Nous contacter': 'Contattaci',
  'Marge commerciale': 'Margine commerciale',
  'NPA / Localité': 'CAP / Località',
  'Mentions légales (CO / SIA)': 'Note legali (CO / SIA)',
  'Largeur (m)': 'Larghezza (m)',
  'Longueur (m)': 'Lunghezza (m)',
  'Jours congés / an': 'Giorni ferie / anno',
  "Lien de l'application": "Link dell'app",
});
Object.assign(I18N.es, {
  Libellé: 'Etiqueta',
  Lieu: 'Lugar',
  Marge: 'Margen',
  'Masse salariale': 'Masa salarial',
  Matériaux: 'Materiales',
  "Main d'œuvre": 'Mano de obra',
  'Montant HT': 'Importe sin IVA',
  'Montant TTC': 'Importe con IVA',
  'Net à payer': 'Neto a pagar',
  Motif: 'Motivo',
  Métier: 'Oficio',
  'Mon activité': 'Mi actividad',
  'Mon salaire': 'Mi salario',
  'Mes rendez-vous': 'Mis citas',
  "Mode d'activité": 'Modo de actividad',
  'Modèle des documents': 'Plantilla de documentos',
  'Modèles de messages': 'Plantillas de mensajes',
  'Langue des documents': 'Idioma de documentos',
  'Informations société': 'Información de empresa',
  'Impayés TTC': 'Impagado (con IVA)',
  'Impayé en cours': 'Pendiente',
  'Encaisser un acompte': 'Cobrar un anticipo',
  'Envoyer la facture au client': 'Enviar factura al cliente',
  'Feuille de présence': 'Hoja de asistencia',
  'Heures pointées (total)': 'Horas registradas (total)',
  'Nombre de jours': 'Número de días',
  'Nom complet': 'Nombre completo',
  'Nom de la prestation': 'Nombre del servicio',
  'Nous contacter': 'Contáctanos',
  'Marge commerciale': 'Margen comercial',
  'NPA / Localité': 'CP / Localidad',
  'Mentions légales (CO / SIA)': 'Avisos legales (CO / SIA)',
  'Largeur (m)': 'Ancho (m)',
  'Longueur (m)': 'Largo (m)',
  'Jours congés / an': 'Días vacaciones / año',
  "Lien de l'application": 'Enlace de la app',
});
Object.assign(I18N.en, {
  'Nouveau client': 'New client',
  'Nouveau frais': 'New expense',
  'Nouveau pointage': 'New time entry',
  'Nouveau rendez-vous': 'New appointment',
  'Nouveau sous-traitant': 'New subcontractor',
  'Nouvel article': 'New item',
  'Nouvel avenant': 'New amendment',
  'Nouvelle commande': 'New order',
  'Nouvelle dépense': 'New expense',
  'Nouvelle vente': 'New sale',
  Objet: 'Subject',
  Pays: 'Country',
  Type: 'Type',
  Surface: 'Area',
  Récapitulatif: 'Summary',
  Signatures: 'Signatures',
  'Sous-traitants': 'Subcontractors',
  'Salaire brut': 'Gross salary',
  'Salaire de base': 'Base salary',
  "Prix d'achat": 'Purchase price',
  'Prix de vente': 'Sale price',
  'Taux de marge': 'Margin rate',
  'Total produits': 'Total income',
  'Total charges': 'Total expenses',
  'Total actif': 'Total assets',
  'Total passif': 'Total liabilities',
  'Total déductions': 'Total deductions',
  'Total dépenses': 'Total expenses',
  'Total facturé HT': 'Total invoiced excl. VAT',
  'Total à encaisser': 'Total to collect',
  "Secteur d'activité": 'Business sector',
  'Rapport journalier': 'Daily report',
  'Refuser le devis': 'Decline quote',
  Remboursements: 'Refunds',
  'Sur le chantier': 'On site',
});
Object.assign(I18N.de, {
  'Nouveau client': 'Neuer Kunde',
  'Nouveau frais': 'Neue Ausgabe',
  'Nouveau pointage': 'Neue Zeiterfassung',
  'Nouveau rendez-vous': 'Neuer Termin',
  'Nouveau sous-traitant': 'Neuer Subunternehmer',
  'Nouvel article': 'Neuer Artikel',
  'Nouvel avenant': 'Neuer Nachtrag',
  'Nouvelle commande': 'Neue Bestellung',
  'Nouvelle dépense': 'Neue Ausgabe',
  'Nouvelle vente': 'Neuer Verkauf',
  Objet: 'Betreff',
  Pays: 'Land',
  Type: 'Typ',
  Surface: 'Fläche',
  Récapitulatif: 'Zusammenfassung',
  Signatures: 'Unterschriften',
  'Sous-traitants': 'Subunternehmer',
  'Salaire brut': 'Bruttolohn',
  'Salaire de base': 'Grundlohn',
  "Prix d'achat": 'Einkaufspreis',
  'Prix de vente': 'Verkaufspreis',
  'Taux de marge': 'Margenrate',
  'Total produits': 'Ertrag total',
  'Total charges': 'Aufwand total',
  'Total actif': 'Aktiven total',
  'Total passif': 'Passiven total',
  'Total déductions': 'Abzüge total',
  'Total dépenses': 'Ausgaben total',
  'Total facturé HT': 'Fakturiert exkl. MwSt',
  'Total à encaisser': 'Total einzuziehen',
  "Secteur d'activité": 'Tätigkeitsbereich',
  'Rapport journalier': 'Tagesrapport',
  'Refuser le devis': 'Offerte ablehnen',
  Remboursements: 'Rückerstattungen',
  'Sur le chantier': 'Auf der Baustelle',
});
Object.assign(I18N.it, {
  'Nouveau client': 'Nuovo cliente',
  'Nouveau frais': 'Nuova spesa',
  'Nouveau pointage': 'Nuova timbratura',
  'Nouveau rendez-vous': 'Nuovo appuntamento',
  'Nouveau sous-traitant': 'Nuovo subappaltatore',
  'Nouvel article': 'Nuovo articolo',
  'Nouvel avenant': 'Nuova variante',
  'Nouvelle commande': 'Nuovo ordine',
  'Nouvelle dépense': 'Nuova spesa',
  'Nouvelle vente': 'Nuova vendita',
  Objet: 'Oggetto',
  Pays: 'Paese',
  Type: 'Tipo',
  Surface: 'Superficie',
  Récapitulatif: 'Riepilogo',
  Signatures: 'Firme',
  'Sous-traitants': 'Subappaltatori',
  'Salaire brut': 'Salario lordo',
  'Salaire de base': 'Salario base',
  "Prix d'achat": "Prezzo d'acquisto",
  'Prix de vente': 'Prezzo di vendita',
  'Taux de marge': 'Tasso di margine',
  'Total produits': 'Totale ricavi',
  'Total charges': 'Totale costi',
  'Total actif': 'Totale attivo',
  'Total passif': 'Totale passivo',
  'Total déductions': 'Totale detrazioni',
  'Total dépenses': 'Totale spese',
  'Total facturé HT': 'Totale fatturato IVA escl.',
  'Total à encaisser': 'Totale da incassare',
  "Secteur d'activité": 'Settore di attività',
  'Rapport journalier': 'Rapporto giornaliero',
  'Refuser le devis': 'Rifiuta preventivo',
  Remboursements: 'Rimborsi',
  'Sur le chantier': 'In cantiere',
});
Object.assign(I18N.es, {
  'Nouveau client': 'Nuevo cliente',
  'Nouveau frais': 'Nuevo gasto',
  'Nouveau pointage': 'Nuevo fichaje',
  'Nouveau rendez-vous': 'Nueva cita',
  'Nouveau sous-traitant': 'Nuevo subcontratista',
  'Nouvel article': 'Nuevo artículo',
  'Nouvel avenant': 'Nueva enmienda',
  'Nouvelle commande': 'Nuevo pedido',
  'Nouvelle dépense': 'Nuevo gasto',
  'Nouvelle vente': 'Nueva venta',
  Objet: 'Asunto',
  Pays: 'País',
  Type: 'Tipo',
  Surface: 'Superficie',
  Récapitulatif: 'Resumen',
  Signatures: 'Firmas',
  'Sous-traitants': 'Subcontratistas',
  'Salaire brut': 'Salario bruto',
  'Salaire de base': 'Salario base',
  "Prix d'achat": 'Precio de compra',
  'Prix de vente': 'Precio de venta',
  'Taux de marge': 'Tasa de margen',
  'Total produits': 'Total ingresos',
  'Total charges': 'Total gastos',
  'Total actif': 'Total activo',
  'Total passif': 'Total pasivo',
  'Total déductions': 'Total deducciones',
  'Total dépenses': 'Total gastos',
  'Total facturé HT': 'Total facturado sin IVA',
  'Total à encaisser': 'Total a cobrar',
  "Secteur d'activité": 'Sector de actividad',
  'Rapport journalier': 'Informe diario',
  'Refuser le devis': 'Rechazar presupuesto',
  Remboursements: 'Reembolsos',
  'Sur le chantier': 'En obra',
});
Object.assign(I18N.en, {
  'Téléphone société': 'Company phone',
  Unité: 'Unit',
  'Valeur stock': 'Stock value',
  Vendre: 'Sell',
  'Ventes caisse': 'Cash sales',
  'Voir la facture en grand': 'View invoice full size',
  'Votre signature électronique': 'Your electronic signature',
  'Vous êtes': 'You are',
  'À libérer': 'To release',
  'À traiter': 'To process',
  'Éléments affichés': 'Items shown',
  'Établir le PV de réception': 'Create acceptance report',
  'Établir une décharge': 'Create a discharge',
  Brouillon: 'Draft',
  Envoyée: 'Sent',
  Payée: 'Paid',
  Partielle: 'Partial',
  Annulée: 'Cancelled',
  Rectifiée: 'Corrected',
  Accepté: 'Accepted',
  Refusé: 'Declined',
  'En attente': 'Pending',
  Approuvé: 'Approved',
  Terminé: 'Done',
  'En cours': 'In progress',
  Reçue: 'Received',
  'À préparer': 'To prepare',
  Prête: 'Ready',
  Livrée: 'Delivered',
  Facturée: 'Invoiced',
  'Suivi commercial (CRM)': 'Sales tracking (CRM)',
  Statut: 'Status',
  Prospect: 'Lead',
  Client: 'Client',
  Perdu: 'Lost',
  'Date de relance': 'Follow-up date',
  'Note de suivi': 'Follow-up note',
  "Chiffre d'affaires": 'Turnover',
  'Compte client': 'Customer account',
  Devis: 'Quote',
  Factures: 'Invoices',
  'Top clients & articles': 'Top clients & items',
  'Tarifs dégressifs (prix selon quantité)': 'Volume pricing (price by quantity)',
});
Object.assign(I18N.de, {
  'Suivi commercial (CRM)': 'Vertrieb (CRM)',
  Statut: 'Status',
  Prospect: 'Interessent',
  Client: 'Kunde',
  Perdu: 'Verloren',
  'Date de relance': 'Wiedervorlage',
  'Note de suivi': 'Notiz',
  'Top clients & articles': 'Top Kunden & Artikel',
  'Tarifs dégressifs (prix selon quantité)': 'Mengenrabatt (Preis nach Menge)',
});
Object.assign(I18N.it, {
  'Suivi commercial (CRM)': 'Vendite (CRM)',
  Statut: 'Stato',
  Prospect: 'Potenziale',
  Client: 'Cliente',
  Perdu: 'Perso',
  'Date de relance': 'Data sollecito',
  'Note de suivi': 'Nota',
  'Top clients & articles': 'Top clienti & articoli',
  'Tarifs dégressifs (prix selon quantité)': 'Prezzi a scaglioni (prezzo per quantità)',
});
Object.assign(I18N.es, {
  'Suivi commercial (CRM)': 'Ventas (CRM)',
  Statut: 'Estado',
  Prospect: 'Prospecto',
  Client: 'Cliente',
  Perdu: 'Perdido',
  'Date de relance': 'Fecha de seguimiento',
  'Note de suivi': 'Nota',
  'Top clients & articles': 'Top clientes y artículos',
  'Tarifs dégressifs (prix selon quantité)': 'Precios por volumen (precio por cantidad)',
});
Object.assign(I18N.de, {
  Brouillon: 'Entwurf',
  Envoyée: 'Gesendet',
  Payée: 'Bezahlt',
  Partielle: 'Teilweise',
  Annulée: 'Storniert',
  Rectifiée: 'Korrigiert',
  Accepté: 'Angenommen',
  Refusé: 'Abgelehnt',
  'En attente': 'Ausstehend',
  Approuvé: 'Genehmigt',
  Terminé: 'Erledigt',
  'En cours': 'Laufend',
  Reçue: 'Erhalten',
  'À préparer': 'Vorzubereiten',
  Prête: 'Bereit',
  Livrée: 'Geliefert',
  Facturée: 'Fakturiert',
});
Object.assign(I18N.it, {
  Brouillon: 'Bozza',
  Envoyée: 'Inviata',
  Payée: 'Pagata',
  Partielle: 'Parziale',
  Annulée: 'Annullata',
  Rectifiée: 'Rettificata',
  Accepté: 'Accettato',
  Refusé: 'Rifiutato',
  'En attente': 'In attesa',
  Approuvé: 'Approvato',
  Terminé: 'Completato',
  'En cours': 'In corso',
  Reçue: 'Ricevuto',
  'À préparer': 'Da preparare',
  Prête: 'Pronto',
  Livrée: 'Consegnato',
  Facturée: 'Fatturato',
});
Object.assign(I18N.es, {
  Brouillon: 'Borrador',
  Envoyée: 'Enviada',
  Payée: 'Pagada',
  Partielle: 'Parcial',
  Annulée: 'Anulada',
  Rectifiée: 'Rectificada',
  Accepté: 'Aceptado',
  Refusé: 'Rechazado',
  'En attente': 'Pendiente',
  Approuvé: 'Aprobado',
  Terminé: 'Terminado',
  'En cours': 'En curso',
  Reçue: 'Recibido',
  'À préparer': 'Por preparar',
  Prête: 'Listo',
  Livrée: 'Entregado',
  Facturée: 'Facturado',
});
Object.assign(I18N.de, {
  'Téléphone société': 'Firmentelefon',
  Unité: 'Einheit',
  'Valeur stock': 'Lagerwert',
  Vendre: 'Verkaufen',
  'Ventes caisse': 'Kassenverkäufe',
  'Voir la facture en grand': 'Rechnung gross ansehen',
  'Votre signature électronique': 'Ihre elektronische Unterschrift',
  'Vous êtes': 'Sie sind',
  'À libérer': 'Freizugeben',
  'À traiter': 'Zu bearbeiten',
  'Éléments affichés': 'Angezeigte Einträge',
  'Établir le PV de réception': 'Abnahmeprotokoll erstellen',
  'Établir une décharge': 'Entlastung erstellen',
});
Object.assign(I18N.it, {
  'Téléphone société': 'Telefono azienda',
  Unité: 'Unità',
  'Valeur stock': 'Valore magazzino',
  Vendre: 'Vendi',
  'Ventes caisse': 'Vendite cassa',
  'Voir la facture en grand': 'Vedi fattura ingrandita',
  'Votre signature électronique': 'La tua firma elettronica',
  'Vous êtes': 'Sei',
  'À libérer': 'Da liberare',
  'À traiter': 'Da trattare',
  'Éléments affichés': 'Elementi mostrati',
  'Établir le PV de réception': 'Crea verbale di consegna',
  'Établir une décharge': 'Crea liberatoria',
});
Object.assign(I18N.es, {
  'Téléphone société': 'Teléfono empresa',
  Unité: 'Unidad',
  'Valeur stock': 'Valor de stock',
  Vendre: 'Vender',
  'Ventes caisse': 'Ventas caja',
  'Voir la facture en grand': 'Ver factura ampliada',
  'Votre signature électronique': 'Su firma electrónica',
  'Vous êtes': 'Usted es',
  'À libérer': 'Por liberar',
  'À traiter': 'Por tratar',
  'Éléments affichés': 'Elementos mostrados',
  'Établir le PV de réception': 'Crear acta de recepción',
  'Établir une décharge': 'Crear descargo',
});

/**
 * Mots féminins parmi les noms de documents que l'interface compose.
 *
 * Le mot change avec le métier et avec la langue : « devis » au bâtiment,
 * « offre » au magasin, et la traduction suisse romande rend « devis » par
 * « offre » elle aussi. L'article, lui, était écrit en dur au masculin — d'où
 * un « Nouveau offre » en tête d'écran.
 */
const FEMININS = ['offre', 'facture', 'prestation', 'commande', 'livraison'];

/**
 * Dit si un nom de document est féminin.
 *
 * @param {string} mot nom du document, déjà traduit
 * @returns {boolean} vrai s'il demande un article féminin
 */
export function estFeminin(mot) {
  return FEMININS.includes(
    String(mot || '')
      .trim()
      .toLowerCase(),
  );
}

/**
 * « Nouveau devis », « Nouvelle offre » : l'article suit le mot.
 *
 * @param {string} mot nom du document, déjà traduit
 * @returns {string} l'intitulé accordé
 */
export function nouveau(mot) {
  return (estFeminin(mot) ? 'Nouvelle ' : 'Nouveau ') + mot;
}

/**
 * « Modifier le devis », « Modifier l'offre ».
 *
 * <p>L'élision se pose devant une voyelle, quel que soit le genre : c'est la
 * première lettre du mot qui commande, non son article.
 *
 * @param {string} mot nom du document, déjà traduit
 * @returns {string} l'intitulé accordé
 */
export function modifierLe(mot) {
  const m = String(mot || '').trim();
  if (/^[aeiouyàâéèêëîïôöùûü]/i.test(m)) {
    return 'Modifier l’' + m;
  }
  return (estFeminin(m) ? 'Modifier la ' : 'Modifier le ') + m;
}

/**
 * « le devis », « l'offre », « la facture » : l'article défini, accordé.
 *
 * @param {string} mot nom du document, déjà traduit
 * @returns {string} l'article et le mot
 */
export function leDocument(mot) {
  const m = String(mot || '').trim();
  if (/^[aeiouyàâéèêëîïôöùûü]/i.test(m)) {
    return 'l’' + m;
  }
  return (estFeminin(m) ? 'la ' : 'le ') + m;
}

/**
 * « ce devis », « cette offre » : le démonstratif, accordé.
 *
 * @param {string} mot nom du document, déjà traduit
 * @returns {string} le démonstratif et le mot
 */
export function ceDocument(mot) {
  const m = String(mot || '').trim();
  return (estFeminin(m) ? 'cette ' : 'ce ') + m;
}

/**
 * « Aucun devis », « Aucune offre » : la négation, accordée.
 *
 * <p>L'état vide est la première chose que voit une entreprise qui vient de
 * s'inscrire : « Aucun offre » y accueillait les magasins, et les entreprises
 * romandes dont le dictionnaire rend « devis » par « offre ».
 *
 * @param {string} mot nom du document, déjà traduit
 * @returns {string} la négation et le mot
 */
export function aucunDocument(mot) {
  const m = String(mot || '').trim();
  return (estFeminin(m) ? 'Aucune ' : 'Aucun ') + m;
}
